import { BrandDto } from "api/repositories/brand/brand.types";
import { getServiceName, getServiceNameEn } from "constants/service/service";
import { COUNTRY_CD } from "constants/country";
import { CATEGORY_ID } from "constants/brand";
import { SelectCommissionProps } from "components/selectCommission/selectCommission";
import { CampaignFormContextProps } from "pages/campaigns/campaignForm/campaignForm.context";
import { getCampaignCommissionOptions } from "api/repositories/campaign/campaign.constants";

const ja = {
    common: {
        _step: (n: any) => `${n}段階`,
        _product_qty: (n: any) => `${n}個`,
        _price: (price: any, unit:string) => `${price}${unit}`,
        _price_10000: (price: any, unit:string) => `${price}万${unit}`,
        _price_10000_short: (price: any, unit:string) => `${price}万${unit}`,
        _amount: (n: any) => `${n}個`,
        _price_per_1ea: (price: any, unit:string) => `1個あたり ${price}${unit}`,
        _listLimit: (n: any) => `最大 ${n}件が表示されます.`,
        _cost: (name: any) => `${name}費用`,
        _num_of_person: (n: any) => `${n}名`,
        _weeks_ago: (n: any) => `${n}週前`,
        _day: (n: any) => `${n}日`,
        _times: (n: any) => `${n}回`,
        _clothes: (n: any) => `${n}着`,
        _wear: (clothes: any) => `${clothes}着用`,
        _age: (n: any) => `${n}歳`,
        _height: (n: any) => `${n}cm`,
        _top_size: (size: any) => `トップス${size}`,
        _bottom_size: (size: any) => `ボトムス${size}`,
        _bra_size: (size: any) => `ブラ${size}`,
        _pantie_size: (size: any) => `パンツ${size}`,
        _shoes_size: (size: any) => `靴${size}`,
        _text_max_length_short: (n: any) => `最大${n}文字`,
        oneulook_base: getServiceName(),
        oneulook_en: getServiceNameEn(true),
        language: '言語',
        korea : '韓国',
        japan : '日本',
        locale_korea : '한국어',
        locale_japan : '日本語',
        currencyUnitKRW: 'ウォン',
        currencyUnitJPY: '円',
        free: '無料',
        id: "ID",
        password: "パスワード",
        login: "ログイン",
        confirm: "確認",
        dont_show_today: "今日は表示しない", 
        posting: "投稿",
        reels: "リール",
        report: "レポート",
        lectures: '講義',
        influencer_page: "インフルエンサー",
        save: "保存",
        save2: "保存する",
        modify: "修正",
        modify2: "修正する",
        change: "変更",
        change2: "変更する",
        delete: "削除",
        delete2: "削除する",
        cancel: "中止",
        cancel2: "中止する",
        add: "追加",
        add2: "追加する",
        start_date: "開始日",
        end_date: "終了日",
        inquiry: "検索",
        button_prev_1: "前の段階に",
        button_prev_2: "前に",
        button_prev_3: "後ろに",
        button_prev_4: "前に",
        button_next_1: "次へ",
        button_next_2: "次へ",
        pay: "決済する",
        payment: "決済",
        paid_date: "決済日",
        last_paid_date: "前回の決済日",
        input_error_1: "入力内容を確認してください。",
        payment_history1: "決済内容",
        payment_history2: "決済内容",
        check_payment_history: "決済内容の確認",
        select_file_plz: "アップロードするファイルを選択してください",
        error: "エラー",
        load: "呼び出す",
        loading_1: "呼び出し中です...",
        excel: "エクセル",
        applicants_count: "応募者数",
        bills: "領収書",
        one_line_desc: "一行で説明 (選択)",
        introduce: "紹介",
        guideline: "ガイドライン",
        manager_page: "管理者ページ",
        popularity: "人気",
        new: "NEW",
        logout: "ログアウト",
        manage_card: "カード管理",
        release: "解除",
        close: "閉じる",
        close2: "戻る",
        like: "いいね",
        followers: "フォロワー",
        dibs: "お気に入り数",
        cum_sel: "累積選定",
        instagram: "Instagram",
        instagram_opened: "確認しました",
        instagram_confirmed: "確認済み",
        view_on_instagram: "Instagramで見る",
        view_appeal_reels: "代表リールを見る",

        view_models_other_posting: (category_id) => {
            switch(category_id){
            case CATEGORY_ID.BEAUTY:
            return "このインフルエンサーの他のリールを見る";
            default:
            return "このインフルエンサーの他の投稿を見る";
            }    
        },            
        view_products_other_posting: (category_id) => {
            switch(category_id){
            case CATEGORY_ID.BEAUTY:
            return "この商品のリールを見る";
            default:
            return "この商品の他の投稿を見る";
            }    
        },            
        rent_product: "商品貸与",
        create_n_manage: "作成および管理",
        product_presentation: "商品提供",
        campaign: "キャンペーン",
        connect_company_mall: "自社サイト連動",
        connect_n_manage: "連動および管理",
        invite_offline: "オフライン招待",
        transaction_info: "特定商取引法に基づく表記",
        change_password: "パスワード変更",
        setting_alarm: "通知設定",
        brand: "ブランド",
        setting_brand: "ブランド設定",
        copy: 'コピーする',
        copy_button_default_text: "コピー",
        copy_button_completed_text: "コピー完了",
        copy_result_completed_text: "コピーが完了されました。",
        copy_result_failed_text: "コピーが制限されました。",
        is_first_visit: "始めてでしょうか？",
        brand_info: "ブランド情報",
        show_detail: "詳しく見る",
        show_more: "もっと見る",
        used_date: "使用日",
        used_count: "使用個数",
        none_history: "利用内容がありません",
        input_tracking_num: "送り状番号入力",
        ignore_guideline: "ガイドライン未順守",
        ignore_posting_deadline: "投稿期間未順守",
        approve: "選定する",
        decline: "脱落させる",
        start: "スタート",
        start2: "スタートする",
        expiration_date: "利用満了日",
        next_payment_date: "次回購入日",
        payment_method: "決済手段",
        total_price: "総額",
        date_format: "YYYY年 MM月 DD日",
        date_format2: "YY年 MM月 DD日",
        date_format3: "M月 D日 dddd",
        date_format_month: "YYYY年 MM月",
        payment_info: "決済情報",
        payment_card_update: "決済カードを変更する",
        apply: "適用",
        this_week: "今週",
        hide: "隠す",
        search: "検索",
        number: "番号",
        omission: "漏れ",
        color: "色",
        color_value: "色値",
        color_name: "色名",
        size: "サイズ",
        amount: "数量",
        input: "入力",
        select: "選択",
        gender: "性別",
        male: "男性",
        female: "女性",
        season: "季節",
        spring: "春",
        summer: "夏",
        fall: "秋",
        winter: "冬",
        style: "スタイル",
        agreement: "同意",
        done: "完了",
        send: "送信",
        notdone: "未完了",
        product: "商品",
        sub_item: "副資材",
        image: "イメージ",
        state: "状態",
        unlimited: "無制限",
        _currency: (unit) => unit,
        none: "なし",
        update: "アップデート",
        name: "名前",
        role: "役職",
        title: "タイトル",
        product_name: "商品名",
        age: "年齢",
        height: "背",
        public: "公開",
        private: "非公開",
        photo: "写真",
        wholesale_manager: "社長",
        mobile_left: "",
        mobile_left_placeholder: "080",
        country_code : COUNTRY_CD.JP,
        contact_country_code : '国名コード',
        country_code_empty : '国名コードを選択してください。',
        is_requesting: 'リクエスト中です。',
        selection: '選択',
        optional: '選択',
        yes: "はい",
        no: "いいえ",
        recommendation: "推奨",
        download: `ダウンロード`,
        subtitle: "字幕",
        etc: `その他`,
        deadline: `期限`,

        sort_order_applied_at: `最新申請順`,
        sort_order_commission_asc: `希望PR費用低い順`,
        sort_order_commission_desc: `希望PR費用高い順`,

        model_support_title_1: "모델 밀어주기 취소하기　ない単語1",
        model_support_title_2: "모델 밀어주기　ない単語2",
        model_support_text_1: "모델 밀어주기를 취소하시겠습니까？　ない単語3",
        model_support_text_2: "우리 브랜드 옷을 더 입도록 밀어줍니다.　ない単語4",
        model_reject_title_1: "インフルエンサーの除外を中止する",
        model_reject_title_2: "インフルエンサーを除外する",
        model_reject_text_1: "インフルエンサーの除外を中止されますか？",
        model_reject_text_2: "私たちのブランドの服を参加できないように設定する。",

        guideline_final_check_title: 'ガイドライン最終チェック',
        guideline_final_check_description: 'ガイドラインに問題がないか最後にご確認ください。',
        guideline_confirm_button: '確認',
        guideline_check_title: 'ガイドライン確認',
        guideline_no_issue_confirmed: '問題がないことを確認しました',
    },
    constants: {
        OPTION_TRANSLATION_MAP: {
            PHOTO_MODEL_FULL: '商品着用ショット-正面で立って(頭・つま先が切れないように)',
            PHOTO_MODEL_HALF: '商品着用ショット-半身ショット',
            PHOTO_MODEL_CLOSEUP: '商品着用ショット-商品ディテールクローズアップ',
            PHOTO_MODEL_WITHOUT_FACE: '着用ショット - 顔から下の商品を中心としたショット',
            PHOTO_PRODUCT_FULL: '商品単独ショット-商品全体ショット',
            PHOTO_PRODUCT_CLOSEUP: '商品単独ショット-商品ディテールクローズアップ',
            REELS_BEAUTY_PRODUCT_SELFIE: '商品を持って撮ったセルカ',
            REELS_BEAUTY_PRODUCT_TRY: '商品を塗るシーン',
            REELS_BEAUTY_PRODUCT_FULL: '商品単独ショット',
            REELS_PRODUCT : "商品単独カット", 
            REELS_PRODUCT_PACKAGE : "パッケージ単独カット", 
            REELS_PRODUCT_TEXTURE : "テクスチャー表現カット", 
            REELS_PRODUCT_COLOR : "発色表現カット(メイクアップ商品の場合は推奨)", 
            REELS_PRODUCT_TRY : "商品使用カット", 
            REELS_PRODUCT_BEFORE_AFTER : "使用前/使用後カット", 
            REELS_PRODUCT_SELFIE : "商品を手に持って撮ったセルカカット", 
            SUBTITLE_OPENING : "1秒目のキャッチフレーズ", 
            SUBTITLE_MIDDLE : "性能/効果/使用方法", 
            SUBTITLE_CLOSING : "プロモーションおよびイベント", 
            CONTENT : "投稿文内容入力", 
            VIDEO_DURATION : "動画長さの最低秒数", 
            CO_AUTHOR : "共同投稿者を追加", 
            PROHIBITIONS_MASK: "マスク着用禁止",
            PROHIBITIONS_MIRROR_SELFIE: "鏡セルフィ―禁止",
            PROHIBITIONS_OTHER_PEOPLE: "他の人と一緒に映った写真禁止",
            PROHIBITIONS_INDOORS: "室内撮影禁止",
            PROHIBITIONS_PLACE_ROOFTOP: "屋上、廊下、駐車場、家での撮影禁止",

            PROHIBITIONS_BEAUTY_GRWM_AND_OTHER_PRODUCTS: "GRWM動画は禁止、提供商品だけを単独で紹介",
            PROHIBITIONS_BEAUTY_MAKE_UP: "基礎化粧品の場合は、必ずスッピン状態で撮影",
            PROHIBITIONS_BEAUTY_TPO_MISMATCH: "商品のカラーと雰囲気に合う洋服での撮影を推奨",
            PROHIBITIONS_BEAUTY_FINGERPRINTS: "商品や鏡の指紋とほこりは必ず拭いてから撮影", 
            PROHIBITIONS_BEAUTY_ENLARGE: "撮影した動画の拡大は禁止、はじめからクローズアップで撮影",
            PROHIBITIONS_BEAUTY_SLIDESHOW: "写真を繋ぎ合わせる方式の編集は禁止",
            PROHIBITIONS_BEAUTY_COMMERCIAL_CONTENTS: "著作権問題のないフォント及びBGMのみを使用",
            PROHIBITIONS_BEAUTY_HDR: "iPhoneの場合、必ずHDR設定をオフにして撮影",
            PROHIBITIONS_BEAUTY_DEADZONE: "文字が被ってしまう部分に字幕・ロゴの挿入禁止",

            REQUIREMENTS_IRONING: "商品着用前のアイロンがけを必須でお願いいたします。",
            REQUIREMENTS_VIDEO_CLEAN: "文字入れ前動画の提出を必須とさせていただきます。",
            
            HASH_TAG_LOCATION_POST: "投稿文内に入れる",
            HASH_TAG_LOCATION_COMMENT: "投稿コメントに入れる",
            ALLOW_ADVERTISEMENT_TAG_ALLOW: "#PRを必須で記載してください。",
            ALLOW_ADVERTISEMENT_TAG_DISALLOW:
                "#PR #提供タグを含まないとして推奨したいです。ない単語",
            ALLOW_OTHER_AT_TAG_ALLOW: "他ブランドのタグを一緒に入れても構いません。",
            ALLOW_OTHER_AT_TAG_DISALLOW: "私たちのブランドタグだけつけてください。",

            VIDEO_DURATION_TWOWENTY: "20秒以上",
            VIDEO_DURATION_THIRTY: "30秒以上",

            PREFERRED_VIDEO_TYPE_EMOTIONAL: "感性・雰囲気型",
            PREFERRED_VIDEO_TYPE_INFOMATIVE: "商品説明重視型",
            PREFERRED_VIDEO_TYPE_VISITING: "店舗訪問型",
            PREFERRED_VIDEO_TYPE_OY_VISITING: "올영세일 방문형",
            PREFERRED_VIDEO_TYPE_OY_PRODUCT_ONLY: "올영세일 제품소개형",

            REQUIRE_PARTNERSHIP_CODE_REQUIRED: "必要です。",
            REQUIRE_PARTNERSHIP_CODE_NOT_REQUIRED: "必要ありません。",

        },
    },
    database: {
        posting_videos: {
          content_type_code_1: '文字入れ前動画',
          content_type_code_2: 'オリジナル動画',
        },
        product: {
            status_fl_1: `作成中`,
            status_fl_2: `検収中`,
            status_fl_3: `入庫中`,
            status_fl_4: `進行中`,
            status_fl_5: `返却要請`,
            status_fl_6: `返却要請受付`,
            status_fl_7: `返却中`,
            status_fl_8: `返却`,
            status_fl_9: `シーズンアウト`,
        },
        rental_posting_due: {
            reason_type_1: `配送遅延`,
            reason_type_2: `ガイドライン違反による再撮影`,
            reason_type_3: `健康上の問題`,
            reason_type_9: `その他`,
        },
        campaign_payments: {
          billing_type: {
            FREE: "現金",
            PAID: "カード",   
          },
        },
    },
    component: {
        ambassadorApplicantsToast: {
            _applicants: (n: number) => (
                <>
                    {`アンバサダーインフルエンサーの応募者が`}
                    <span className="text-[#000000] font-bold">{`${n}名`}</span>
                    います。
                </>
            ),
            button_select: "選定しに行く",
        },
        buttonCleanVideoDownload: {
            pre_payment_modal_title: `文字入れ前動画(カット編集まで)のダウンロード費用を決済してください。`,
            pre_payment_modal_description: [
                `完成したリールを広告素材としてご利用される予定であれば、`,
                `字幕とBGMのないカット編集までが完了した`,
                `文字入れ前動画の使用をおすすめします。`,
                ``,
                `ダウンロードした文字入れ前動画は`,
                `期間および用途に制限なく自由にご利用いただけます。`
            ].join(`\n`),
        },
        campaignApplicantItem: {
            _modelSizeLine0: (age: number) => `${age}歳`,
            _modelSizeLine1: (topSize: number, bottomSize: number) =>
                ` / トップス ${topSize}, ボトムス ${bottomSize}`,
            _modelSizeLine2: (braSize: number, pantieSize: number) =>
                ` / ブラ ${braSize}, パンツ ${pantieSize}`,
            _modelSizeLine3: (shoesSize: number) => ` / 靴 ${shoesSize}`,
            modal_title_1: "出庫完了",
            modal_title_2: "出庫完了解除",
            modal_text_1: "出庫を完了されますか？",
            modal_text_2: "出庫完了状態を解除されますか？",
            prepared: "出庫完了",
            prepared2: "出庫完了済",
        },
        campaignPaymentHistoryItem: {
            index_text_1: "現金決済",
            index_text_2: "カード決済",
            index_text_3: "請求書発行予定",
            index_text_4: "請求書発行不要",
            index_text_5: "追加選定",
            index_text_6: "請求書発行完了",
        },
        card: {
            modal_toggle_active_text: "該当カードを決済カードに設定されますか？",
            delete_card_text_1: "商品提供の自動決済を中止する",
            delete_card_text_2: "商品貸与の利用を中断する",
            modal_alert_1_text: "利用中のサービス 利用中断からしてください。",
            modal_delete_confirm: "該当カード情報を削除されますか？",
            pay_card: "決済カード",
        },
        createEmergencyProductSub: {},
        createProductMasterModal: {
          category: 'カテゴリー',
          parent_category: "親カテゴリー",
          child_category: "子カテゴリー",
          child_category_placeholder: '親カテゴリーをまず選択してください。',
        },
        guideImage: {},
        guidelineCounter: {
            fashion_index_placeholder: `該当部分を入力してください。(例：ロゴ)`,
        },
        header: {},
        inputDate: {},
        modal: {},
        modalContactManager: {
            modal_contact_manager_index_1: "黒澤 杏香",
            _modal_contact_manager_index_2: (name: string) => {
                if (name.length > 0)
                    name = name + " ";
                return (
                    <>
                        {name}担当者様、はじめまして。
                        <br />
                        5分以内にお電話いたします。
                        <br />
                        後ほどよろしくお願いいたします！
                    </>
                )
            }
        },
        modelCard: {
            _modelsComment: (name: string) => `${name}の${'\n'}コメント`,
            application_message_view: "応募コメントを見る",
            _modelSize0: (age: number) => `${age}歳`,
            _modelSize1: (
                height: number,
                topSize: number,
                bottomSize: number
            ) =>
                ` · ${height}cm · トップス ${topSize} · ボトムス ${bottomSize}`,
            _modelSize2: (shoesSize: number) => `靴 ${shoesSize}`,
            _modelSize3: (braSize: number, pantieSize: number) =>
                `ブラ ${braSize} · パンツ ${pantieSize}`,
            _modelSelHistory: (name: string) =>
                `${name}インフルエンサーが${'\n'}最近1ヶ月間に自社ブランドに選定された履歴`,
            _modelSelHistoryEntirePeriod: (name: string, number: number) => `${name}様をこれまで当社で合計${number}回選定`,
            _modelProductsAppliedInBrand: (name: string, number: number) => `${name}様は現在当社のキャンペーンに合計${number}件応募中`,
            modal_reject_title_1: "インフルエンサーの削除を中止する",
            modal_reject_title_2: "インフルエンサーを削除する",
            modal_reject_text_1: "インフルエンサーの削除を中止されますか？",
            modal_reject_text_2: `今後自社のキャンペーンから除外する${"\n"}**自社ブランドのキャンペーンに申請できないように設定します。${"\n"}*インフルエンサーには除外内容は通知されません。`,
            non_bg_user: "背景写真を登録していない使用者です。",
            sel_history: `最近1ヶ月間に選定した履歴 : `,
            sel_history_entire_period: "過去に選定した履歴あり",
            products_applied_in_brand: "当社キャンペーンに応募中",
            dibs_model_1: "お気に入り済",
            dibs_model_2: "お気に入りにする",
            brand_like_influencer_1: "保存済み",    
            brand_like_influencer_2: "保存しておく",  
            product_like_influencer_1: "お気に入り済み",             
            product_like_influencer_2: "このキャンペーンのみお気に入り",
            brand_like_modal_menu_info_1: "「インフルエンサー」メニューで確認可能",
            brand_like_modal_menu_info_2: "保存したインフルエンサーはホームページ上部の\n「インフルエンサー」メニューで確認できます.",
            extended_posting_deadline: "投稿期限を延長しました。",
            exceeded_posting_deadline: "投稿期限が超過しました。",
            exceeded_inspection_deadline: "事前チェックファイルの提出期限を超過しました。",
            select_model_1: "インフルエンサーお気に入り済",
            select_model_2: "インフルエンサーお気に入り",
            suggested_by_admin : `${getServiceName()} 推薦`,
            new_influencer_within_30_days: '新入',
            ambassador_approved: `アンバサダー選定`,
            brand_reselected: `ブランドによる再選択数`,
            should_check_reels_modal_title: `リール作成履歴を必ず確認してください。`,
            should_check_reels_modal_text: `化粧品を持って写真を撮ることはとても簡単です。必ずリール作成経験、およびクオリティが高いかどうかを確認してください。`,
            not_visible_today: `今日一日表示しない`,
            commission_amount_applied : (price, unit) => `${price}万${unit}にて応募`,
            increased_commission_amount_applied: (price, unit) => `${price}万${unit}に引き上げ応募`,
            original_commission_amount_applied: (price, unit) => `${price}万${unit}のまま応募`,
            influencer_message_button_text: '選定時に送るメッセージを事前に入力',
            influencer_message_button_text_completed: '入力完了',
            influencer_message_button_text_cannot_modify_message: '選定時に送ったメッセージを見る',
            influencer_message_button_text_cannot_modify_empty_message: '選定時に送ったメッセージはありません',
            message_modal_title: '選定時に送るメッセージを事前に入力しておく',
            message_modal_seelct_title: '選定されたインフルエンサーに送るメッセージを入力する',
            message_modal_model_type_suggested: '推薦モデル',
            message_modal_model_type_normal: '一般モデル',
            message_modal_representative_reels_view: '代表リールを見る',
            message_modal_placeholder:
            '（例）今回うまく制作していただければ、毎月ご依頼したいと考えています。',
            message_modal_comfirm: '完了',
            message_modal_desc:
            '入力された内容は、インフルエンサーが必ず守らなければならない義務ではありません。',
            message_model_not_input: '送信したメッセージがありません。',
            message_modal_title_not_modify: '選定時に送ったメッセージを見る',
        },
        notification: {},
        matchRatingsEditor: {
            index_text_1: `私たちのブランドのスタイルを\n重要度の順にすべて選択してください。`,
            index_text_2: `私たちのブランドに\n該当するカテゴリがあれば選択してください。`,
            index_text_3: `全く見たくないカテゴリのモデルがあれば選択してください。`,
            index_text_4: `修正されました。`,
            index_text_5: `スタイル`,
            index_text_6: `私たちのブランドに該当するカテゴリ（選択）`,
            index_text_7: `該当するカテゴリがある場合のみ選択してください。`,
            index_text_8: `全く見たくないカテゴリのモデル（選択）`,
        },
        overlayBrandTaxInvoiceInfoForm: { // 일본은 안 쓰는 기능이라 번역 X
          index_text_title: '이 캠페인의 세금계산서 발급 정보',
          index_text_tax_invoice_date_title: '세금계산서 발급 날짜',
          index_text_deposit_date_title: '입금 예정일',
          _index_text_download_business_registration_certificate: (serviceName: string) => `${serviceName} 사업자등록증\n다운로드`,
          _index_text_download_copy_of_bankbook : (serviceName: string) => `${serviceName} 통장사본\n다운로드`,
          index_text_business_name: '사업자등록증의 회사명',
          index_text_business_ceo_name: '대표자명',
          index_text_business_number: '사업자등록번호',
          index_text_business_email: '세금계산서용 이메일',
          index_text_error_business_number: '사업자등록번호는 10자리 숫자만 입력 가능합니다.',
          index_text_error_emails_count: 'メールアドレスは最大2件まで入力できます。',
          index_text_warning_1_title: `이메일 변경 시 주의사항`,
          index_text_warning_1_description: `여기서 이메일을 변경하면,\n브랜드 정보 및 모든 캠페인의 세금계산서용 이메일 정보에 반영됩니다.`,
        },
        overlayMatchRatingSetting: {
            index_text_1: `私たちのブランドのスタイルを\n重要度の順にすべて選択してください。`,
            index_text_2: `私たちのブランドに\n該当するカテゴリがあれば選択してください。`,
            index_text_3: `全く見たくないカテゴリのモデルがあれば選択してください。`,
            index_text_4: `修正されました。`,
            index_text_5: `ブランド情報にも適用されます。`,
            index_text_6: `ここで変更した内容は\nブランド情報にも適用されます。`,
            index_text_7: `再度表示しない`,
        },
        photoGuidelines: {
            _modal_text: (limit: any) => `写真は${limit}枚を超えることはできません。`,
            modal_title: "写真最大受領制限",
            index_text_1: "その必須他要請事項",
            index_text_2: "内容",
            index_text_3: `必須写真の合計枚数は4枚が適正です。\n写真数が増えるとインフルエンサーの申請率が低くなってしまいます。`,
            
            _index_text_4: (current:number, maximum:number)=>(
                `(${current}/${maximum} ${maximum}文字以内)`
            ),
        },
        reelsGuidelines: {
            _modal_text: (limit: any) => `写真は${limit}枚を超えることはできません。`,
            modal_title: "写真最大受領制限",
            index_text_before_after_warning_ja: "*該当カットが必要な場合、薬事法を考慮し記載をお願い致します。",
            index_text_3: `必須写真の合計枚数は4枚が適正です。\n写真数が増えるとインフルエンサーの申請率が低くなってしまいます。`,
            index_text_5: `必須シーンを5個選択されました。`, 
            index_text_6: `6個からは応募率が下がる可能性があるので\n必ず必要なシーンなのかを考慮した後に選択してください。`,
        },
        popup: {},
        posting: {
            model_supporting: "밀어주기 중　ない単語6",
            model_rejecting: "除外中",
            model_support: "밀어주기　ない単語7",
            mode_reject: "除外する",
        },
        postingCard: {
            brandRequestCreateButton: {
                index_1: "原本動画・文字入れ前動画ファイルが今すぐ必要でしょうか？",
                modal_request_step_1_title: "原本動画・文字入れ前動画ファイルが\n今すぐ必要でしょうか？",
                modal_request_step_1_content: `Glovv検収チームに\n"即時検収完了処理"をリクエストいただければ、\n\n` + 
                    "確認後すぐに原本動画および文字入れ前動画ファイルをダウンロードできるよう\nステータスを変更いたします。\n\n" +
                    "ただしこのようにステータスを変更した場合、\n\n" + 
                    "インフルエンサーへ追加修正の依頼はできなくなりますので\nご注意ください。\n\n" + 
                    "今すぐ検収完了処理をリクエストされますか？",
                modal_request_step_1_confirm: "検収完了処理をリクエストする",
                modal_request_step_2_title: "検収完了処理リクエストの送信完了",
                modal_request_step_2_content: "Glovv検収チームに\n検収完了処理のリクエストが送信されました。\n\n" +
                    "原本動画・文字入れ前動画ファイルをダウンロードできるよう\n確認後すぐにステータスを変更いたします。",
            },
            validationStatusIndicator: {
                posting_status_validating: "deprecated_投稿検収中",
                posting_status_validated: "deprecated_投稿検収完了",
                posting_status_modifying: "deprecated_投稿修正待機中",
                _posting_status_modifying: () => (
                    <>
                        投稿がガイドラインを違反したので
                        <br />
                        修正要請をしている状態です。
                    </>
                ),
                posting_status_revalidating: "deprecated_修正された投稿を検収中",
                _posting_status_revalidating: () => (
                    <>
                      수정해서 다시 올라온 버전을<br />
                      다시 검수 중입니다.
                    </>
                ),
                btn_open_feedbacks_modal: "違反内容を見る",
            },
            _createdAtDate: (date: string) => `${date}に登録しました.`,
            _modelWear1: (colorName: string, shoesSize: number) => `${colorName} / ${shoesSize} 着用`,
            _modelWear2: (colorName: string, braSize: number, pantieSize: number) => `${colorName} / ${braSize} / ${pantieSize} 着用`,
            _modelWear3: (colorName: string, sizeName: number) => `${colorName} / ${sizeName} 着用`,
            _modelSize1: (age: number, height: number, topSize: number, bottomSize: number) => `${age}歳 / ${height}cm / トップス ${topSize}, ボトムス ${bottomSize} `,
            _modelSize2: (braSize: number, pantieSize: number) => `/ ブラ ${braSize} / パンツ ${pantieSize} `,
            _modelSize3: (shoesSize: number) => `/ 靴 ${shoesSize} / `,
            _modelWarningReason: (reason: string) => `事由 : ${reason}`,
            _modelReshootingDate: (date: string) => `再撮影予定日 : ${date}`,
            _dayPassed: (diff: number) => `${diff}日超過`,
            _dayRemaining: (diff: number) => `あと${diff}日`,
            dayToday: `今日まで`,
            model_suggested: "おすすめインフルエンサー",
            model_not_suggested: "一般インフルエンサー",
            rating_tooltip:
                "星評価はインフルエンサーには共有されません。正直な評価をお願いいたします。",
            model_reject_1: "キャンペーン申請禁止を解除する",
            model_reject_2: "キャンペーン申請禁止を要請する",
            model_reject_3: "商品の着用禁止を解除する",
            model_reject_4: "商品の着用禁止を要請する",            
            modal_alert_download: "他ブランドの原本写真をダウンロードできません。",
            downloaad_all_images: "写真全体ダウンロード",
            not_include_persons_tag: "人物タグを含んでいない",
            model_guideline_warning:
                "インフルエンサーにガイドライン違反として注意しました。",
            model_likes_1: "お気に入り済",
            model_likes_2: "インフルエンサーをお気に入りに追加",
            brand_like_influencer_1: "保存済み",    
            brand_like_influencer_2: "保存しておく",
            brand_feedback_btn_text: "このリール動画やインフルエンサーにご不満がありましたか？",
            brand_feedback_modal_1_title: `リール動画またはインフルエンサーに関するフィードバックを残す`,
            brand_feedback_modal_1_text: `リール動画作成に関してご不満な点がございましたでしょうか？\n\nフィードバックを残していただければ、Glovvチームがすぐに確認し\nインフルエンサーの評価において最も重要な基準として活用させていただきます。\n\nできる限り率直なご意見をいただけますと幸いです。`,
            brand_feedback_modal_2_title: `フィードバック提出完了`,
            brand_feedback_modal_2_text: `率直なご意見ありがとうございます。`,
            index_text_1: "違反内容",
            index_text_2: "投稿に入れなければいけない必須文言を入力していません",
            _index_text_3: () => (
                <>
                    事前に準備する冬のかばんがおすすめ！ 脱着が可能な2種類のストラップで
                    毎日違うスタイルに変身可能！
                </>
            ),
            index_text_4: "人物タグを投稿の1枚目に入れていません。",
            _index_text_5: () => (
                <>
                    人物タグで他のブランドのタグ、または本人のアカウントのタグを一緒に挿入しました。
                </>
            ),
            index_text_6: "ハッシュタグを投稿文の中に記入しませんでした。",
            _index_text_7: () => (
                <>
                    @hoze #HOZE #MYHOZE #冬コーデ #冬かばんおすすめ #デイリーバッグ
                    #女性用かばん #クリスマスプレゼント
                </>
            ),
            index_text_8: "ハッシュタグをコメント欄に入れませんでした。",
            _index_text_9: () => (
                <>
                    @hoze #HOZE #MYHOZE #冬コーデ #冬かばんおすすめ #デイリーバッグ
                    #女性用かばん #クリスマスプレゼント
                </>
            ),
            index_text_10: "ハッシュタグをコメント欄ではなく投稿文に入れました。",
            _index_text_11: () => (
                <>
                    @hoze #HOZE #MYHOZE #冬コーデ #冬かばんおすすめ #デイリーバッグ
                    #女性用かばん #クリスマスプレゼント
                </>
            ),
            index_text_12: "ハッシュタグを投稿文ではなくコメント欄に入れました。",
            _index_text_13: () => (
                <>
                    @hoze #HOZE #MYHOZE #冬コーデ #冬かばんおすすめ #デイリーバッグ
                    #女性用かばん #クリスマスプレゼント
                </>
            ),
            index_text_14: "リールがガイドラインを違反しました。",
            _index_text_15: () => (
                <>
                    明るく笑ってください！ 明るく笑ってください！ 明るく笑ってください！
                    明るく笑ってください！ 明るく笑ってください！ 明るく笑ってください！
                    明るく笑ってください！
                </>
            ),
            _index_text_16: () => (
                <>
                    違反内容: 頭、つま先が切れていて、背景がコンビニで、
                    鏡セルカで撮影されています。
                </>
            ),
            index_text_17: "ガイドラインを違反したリール:",
            index_text_18: "再投稿したリール:",
            index_text_19: "写真がガイドラインを違反しました。",
            _index_text_20: () => (
                <>
                    違反内容: 頭、つま先が切れていて、背景がコンビニで、
                    鏡セルカで撮影されています。
                </>
            ),
            _index_text_21: () => (
                <>
                    インフルエンサーが投稿した
                    <br />
                    ガイドライン違反写真
                </>
            ),
            _index_text_22: () => (
                <>
                    インフルエンサーが
                    <br />
                    再投稿した写真
                </>
            ),
            index_text_30: "部位",
            index_text_31: "着用ショット - 全身",
            index_text_32: "着用ショット - 半身",
            index_text_33: "着用ショット - クローズアップ",
            index_text_34: "着用ショット - 全体",
            index_text_35: "着用ショット - クローズアップ",
            index_text_36: "違反事項の要請中にエラーが発生しました。\n再読み込み後にもう一度実行してください。",
            index_text_37: "検収完了",
            index_text_38: "検収中",
            index_text_39: "修正待機中",
            index_text_40: "수정본 검수 중",
            index_text_41: "着用ショット - 顔から下の商品を中心としたショット",
            reels_creation_deadline: "リール投稿作成期間",
            validation_status_inspection_initial: "사전 검수 기간",
            validation_status_inspection_fixed: "수정 및 업로드 준비 중",
            validation_status_inspection_validating: "최종 검수 중",
            clean_video_container_title: `文字入れ前動画ファイル`,
            clean_video_container_description_1: `検収完了後ダウンロードが可能です。`,
            clean_video_container_description_2: `期間・用途に制限なく自由にご利用いただけます。`,
            inspection_initial_video_container_title: `原本ファイル`,
            inspection_initial_video_container_description_1: `検収が完了するとダウンロードできます。`,
            inspection_initial_video_container_description_2: `期間や用途の制限なく自由にご利用いただけます。`,
            inspection_fixed_video_container_title: `修正版ファイル`,
            inspection_fixed_video_container_description_1: `検収が完了するとダウンロードできます。`,
            inspection_fixed_video_container_description_2: `期間や用途の制限なく自由にご利用いただけます。`,
            published_video_container_title: `オリジナル動画ダウンロード `,
            published_video_container_description_1: `検収完了後ダウンロードが可能です。`,
            published_video_container_description_2: `期間・用途に制限なく自由にご利用いただけます。`,
            video_description : <>下記メールアドレスへ<br/>ファイルをお送りいたします。</>,
            partnership_code_title: `パートナーシップ広告コード`,
            partnership_code_description_not_validated: `検収完了後に確認が可能です。`,
            partnership_code_description_empty: `入力されたコードがありません。`,
            inspection_created_date: (date) => `${date}提出`,
            inspection_campaign_title : `事前チェックキャンペーン`,
            inspection_status_completed : `検収終了`,
            inspection_remain_time : (remainTimeStr) => `${remainTimeStr}以内に検収する`,
            feedback_reason_title_1: `必須シーンが動画に含まれていません。`,
            feedback_reason_title_2: `必須シーン関連の詳細伝達事項を守っていません。`,
            feedback_reason_title_3: `必須シーン関連のその他伝達事項を守っていません。`,
            feedback_reason_title_4: `提供商品以外の他の商品まで動画で一緒に紹介しています。`,
            feedback_reason_title_5: `基礎化粧品にも関わらずスッピンで撮影していません。`,
            feedback_reason_title_6: `商品のカラーと雰囲気に合わない洋服です。`,
            feedback_reason_title_7: `商品や鏡の指紋とほこりを拭かずに撮影しています。`,
            feedback_reason_title_8: `撮影した動画を拡大して使用したため、画質がかなり悪くなった動画を作成されました。`,
            feedback_reason_title_9: `写真を繋ぎ合わせた方式の編集をされました。`,
            feedback_reason_title_10: `著作権の問題があるフォント及びBGMを使用されました。`,
            feedback_reason_title_11: `動画長さの最低秒数を守っていません。`,
            feedback_reason_title_12: `字幕に入っていない内容があります。`,
            feedback_reason_title_13: `投稿文に入っていない内容があります。`,
            feedback_reason_title_14: `人物タグが挿入されていません。`,
            feedback_reason_title_15: `投稿文またはコメント欄に入れなければならないタグが挿入されていません。`,
            feedback_reason_title_16: `共同投稿者を追加していません。`,
            feedback_reason_title_17: `好みの動画タイプを守りませんでした。`,
            feedback_reason_title_18: `ブランドより提供された追加ガイドラインを遵守しませんでした。`,
            feedback_reason_title_19: `ブランドのロゴファイルが使用されませんでした。`,
            feedback_reason_title_20: `HDR設定をオンにして撮影しました。`,
            feedback_reason_title_21: `文字入れ前動画とは違う動画をアップロードされました。`,
            feedback_reason_title_22: `文字が被ってしまう部分に字幕・ロゴを挿入しました。`,
            feedback_reason_title_23: `ブランドが指定したシーンに記載したフィードバックを守っていません。`,
            feedback_reason_title_24: `字幕フォントの変更（動画全体への適用）がされていません。`,
            feedback_reason_title_25: `字幕サイズの変更（動画全体への適用）がされていません。`,
            feedback_reason_title_26: `BGMの差し替えがされていません。`,
            feedback_reason_title_27: `ナレーションの追加がされていません。`,
            feedback_reason_title_28: `ナレーションの修正がされていません。`,
        },
        product: {
            load_error_1: "商品情報を呼び出せません。",
        },
        sheet: {},
        sidebar: {
            _alertUsePc1: () => (
                <>
                    PCの商品情報入力タブを
                    <br />
                    通して開設をお願いいたします。
                </>
            ),
            _alertUsePc2: () => (
                <>
                    PCの商品提供タブを通して
                    <br />
                    開設をお願いいたします。
                </>
            ),
        },
        snsPaymentHistoryItem: {},
        seedingWithCommissionsAlert : {
            products_count_options: [
                { name: "1", value: 1 },
                { name: "2", value: 2 },
                { name: "3", value: 3 },
                { name: "5", value: 5 },
                { name: "10", value: 10 },
                { name: "20", value: 20 },
                { name: "30", value: 30 },
                { name: "50", value: 50 },
                { name: "100", value: 100 },
            ],
            amount_options: [
                { name: "3", value: 3000 },
                { name: "5", value: 5000 },
                { name: "10", value: 10000 },
                { name: "20", value: 20000 },
                { name: "30", value: 30000 },
                { name: "50", value: 50000 },
            ],
            _title: () => (
                <>
                    PR費用を支給して、
                    <br /> より良いインフルエンサーを利用してみてください！
                </>
            ),
            _title_for_shirts: () => (
                <>
                    Tシャツはカテゴリー特性上
                    <br />
                    応募率が低くなってしまいます。
                    <br />
                    <br />
                    PR費用を追加で支給し、
                    <br />
                    応募率を上げてみてください！
                </>
            ),
            _title_for_underwear: () => (
                <>
                    アンダーウェアはカテゴリー特性上
                    <br/>
                    応募率が低くなってしまいます。
                    <br />
                    <br />
                    PR費用を追加で支給し、
                    <br/>
                    応募率を上げてみてください！
                </>
            ),
            _title_for_reels: () => (
                <>
                    作成難易度が高いリールの場合は特性上
                    <br />
                    応募率が低くなってしまいます。
                    <br />
                    <br />
                    PR費用を追加で支給し、
                    <br/>
                    応募率を上げてみてください！
                </>
            ),
            _body : (unit: string) => (
                <>
                  <p>PR費用を支給すると<span className="#FF0099 font-bold">平均3倍以上</span>応募率が上がります。</p>
                  <p>これまでは応募がなかった<span className="#FF0099 font-bold">クオリティーの高いインフルエンサーが応募</span>します。</p>
                  <br/>
                  <br/>
                  <br/>
                  <p className="font-bold">1. キャンペーン生成後「PR費用を支給する」ボタンをクリック</p>
                  <img className="w-full mt-[20px]" src="/assets/images/commissions/commissions-image-01-ja.png" />
                  <br/>
                  <br/>
                  <p className="font-bold">2. PR費用を設定する</p>
                  <p>リール、Tシャツ、下着の場合は最低5,000{unit}～をおすすめします。</p>
                  <img className="w-full mt-[20px]" src="/assets/images/commissions/commissions-image-02-ja.png" />
                  <br/>
                  <br/>
                  <p className="font-bold">3. 決済後、お望みのインフルエンサーがいない、または多い場合</p>
                  <p>数量変更をお望みであれば、返金または追加決済をいたします。</p>
                </>
                ),
            try_calculate: "予算費用を計算する",
            calculate_amount: "予算費用を計算する",
            calculate_result: "全予算: ",
            _calculate_unit : (unit: string) => unit,
            products_count_unit: "個",
            _amount_currency_unit: (unit: string) => `万${unit}`,
            submit_inquiery: "PR費用支給機能問い合わせ",
            block_until_next_week: "1週間見ない",
            store_contact_msg: "提供 + 手数料利用問い合わせ",
            store_contact_reels_request_msg : 'DEPRECATED_該当商品の成果物の種類の変更を要請されますか？',
            store_contact_reels_msg : 'DEPRECATED_レンタル商品リール問い合わせ',
            seeding_with_commisions_heading:
                "PR費用を支給して、より良いインフルエンサーを利用してみてください！",
            seeding_with_commisions_description:
                "インフルエンサーに商品の提供に加え、金額を支給する機能です。",
            show_detail: "詳しく見る",
        },
        checkbox : {
            recommend : '推奨',
        }
    },
    helper: {
      reactHookForm: {
        error_undefined: '入力値を確認してください。',
        _error_required: (fieldName:string) => `${fieldName}を入力してください。`,
        _error_pattern: (fieldName:string) => `${fieldName}の形式が正しくありません。`,
        _error_validate: (fieldName:string) => `${fieldName}が有効ではありません。`,
      },
      ui: {
        single_day_posting_product_tag: (postingDateText:string) => `[${postingDateText}アップロード必須]`,
      },
      versionChecker: {
        important_update_detected_force: '重要な更新が検出されたため、自動的に再読み込みを実行します。',
        important_update_detected_confirm: '重要な更新が検出されました。再読み込みを実行しますか？',
        important_update_detected_delayed: '更新を延期しました。\n作業完了後、最新バージョンを使用するために再読み込みを実行してください。',
      },
    },
    pages: {
        auth: {
            title: `${getServiceName()}管理者ページ`,
            login_first: "はじめにログインをして\nください。",
            desc_1: "ID・パスワードを忘れた場合は",
            desc_2: "下記番号にご連絡ください。",
            manager: "運営マネージャー",
            manager_tel: "090-5585-4152",
            _contact_text: (url: string) => (
                <p>
                    提携のお問い合わせは&nbsp;
                    <a href={url} className="underline" target="_blank">
                    ここ
                    </a>
                    を押してください。
                </p>
            ),
        },
        influencers: {
            previously_selected_influencer_title: "過去に選定したインフルエンサー",
            previously_selected_influencer_desc: `満足度の高かったインフルエンサーへ優先的に提案できる機能を準備中です。\nガイドラインや期限の不遵守、または低品質なコンテンツなどの理由により\nGlovvでの活動権限が停止されたインフルエンサーは表示されない場合があります。`,
            brand_liked_influencer_title: "保存したインフルエンサー",
            brand_liked_influencer_desc: `保存したインフルエンサーに私たちのキャンペーンに応募するようお願いしてみてください。\nガイドラインや期限の不遵守、または低品質なコンテンツなどの理由により\nGlovvでの活動権限が停止されたインフルエンサーは表示されない場合があります。`,
            no_influencers_found: "該当するインフルエンサーがいません。",
            show_text_sort_by_brand_liked_influencers_date: "保存順",
            show_text_sort_by_brand_liked_influencers_followers: "フォロワー順",
            show_text_sort_by_brand_liked_influencers_previously_selected: "選定回数が多い順",
            show_text_new_influencers: "新人インフルエンサー",
            show_text_recommended_influencers: "推奨インフルエンサー"            
        },
        campaigns: {           
            create: {
              components: {
                preferredVideoTypeSelector: {
                    btn_no_preferred_video_type: "DEPRECATED_特になし",
                    btn_show_example: "例を見る",
                    btn_oy_visiting: "12월 올영세일 매장 방문형",
                    btn_oy_product_only: "12월 올영세일 제품만 소개형",
                },
              }
            },
            payments: {
                groupedByCampaign: {
                    index_text_1: "決済内容",
                    index_text_2: "開設",
                    index_text_3: "未来の日付を選択すると、請求書発行予定の件をご確認いただけます。",
                    index_text_4: (qty:number) => `外 ${qty}件`,
                    index_duration_type_option_1: "キャンペーン開設",
                    index_duration_type_option_2: "請求書発行",
                    index_duration_type_option_3: "カード決済日",
                    index_duration_preset_1: "deprecated_全体期間",
                    index_duration_preset_2: "deprecated_先月",
                    index_duration_preset_3: "deprecated_今月",
                    index_duration_preset_4: "deprecated_来月",
                    index_duration_preset_5: "deprecated_再来月",
                },
            },
            stepOne: {
                modalInspectionAgreements : {
                    title: `事前チェック必須同意事項`,
                    _agreement_1: (priceText: string) => `·  ${priceText}費用追加`,
                    agreement_2: `·  チェックおよび修正要請は1回のみ可能`,
                    agreement_3: `·  再撮影を除き、字幕・フォントなどの修正要請が可能`,
                    agreement_4: `·  BGMがないバージョンを受け取る可能性あり`,
                    agreement_5: `· 検収期限が過ぎるとフィードバック入力画面が自動的に終了し、インフルエンサーがその時点でInstagramにアップロードを開始するため、`,
                    agreement_6: `· 検収期限を過ぎないようご注意ください。`,
                    check_is_agreed: `同意します。`,
                }
            },
            _createPaymentText1: (date: string) => (
                <>
                    {date}まで利用可能ですが、
                    <br />
                    今回作成するキャンペーンがこの日を超過するので追加決済が必要です。
                </>
            ),
            _createPaymentText2: (days: number, price: number, unit: string) => (
                <>
                    現在無制限利用で決済されると、
                    <br /> {days}日に {price / 10000}万{unit}で商品提供キャンペーンを無限に
                    <br />
                    利用できます。
                </>
            ),
            _createPaymentUnlimitedPrice: (days: number, price: number, unit: string) => `無制限:${days}日に ${price / 10000}万${unit}`,
            _createPaymentText23: (days) => (
                <>
                    {days}日後に自動決済され、お好きな時に自動決済の中止が可能です。
                    <br />
                    自動決済後の返金は不可能です。
                </>
            ),
            _excelError1: (lines: Array<string>) => `ダウンロードしたエクセルの内容を変更されましたか？ 変更してはいけません。「送り状番号」の列に送り状番号だけを追加してアップロードしてください。

            問題がある行
            ${lines.join()}`,
            _filterExcelTooltip: () => (
                <>
                    配送情報エクセルをまずダウンロードした後、「送り状番号」を入力し、そのファイルをアップロードしてください。
                </>
            ),
            _excelButton1: (n: number) => `${n}個の商品のインフルエンサー情報をエクセル出力する`,
            option_1: "進行中",
            option_2: "完了",
            product_prepared: "出庫完了",
            header_title: "商品提供キャンペーン",
            header_button_1: "キャンペーン紹介を見る",
            header_button_2_1: "商品提供",
            header_button_2_2: "キャンペーンを開設する",
            filter_check_1: "インフルエンサーを選定しなければいけないキャンペーン",
            filter_check_2: "商品配送をしなければいけないキャンペーン",
            filter_check_3: "送り状番号が未入力のキャンペーンをまとめて見る",
            tracking_number_required_title: '送り状番号を必ず入力してください。',
            tracking_number_required_description: '送り状番号未入力時、紛失についての確認が不可能となります。',
            tracking_number_bulk_input_guide: '送り所番号を一度にまとめて入力する方法を見る',
            _tracking_number_guide_title: () => (
                <>
                  エクセルで送り状番号を<br/>
                  一度に入力する方法
                </>
              ),
            tracking_number_guide_01: '1. エクセルファイルダウンロード',
            tracking_number_guide_02: 'リストからチェックボックスをクリックし、エクセルファイルをダウンロードします。',
            tracking_number_guide_03: '2. エクセルファイルに送り状番号を入力',
            tracking_number_guide_04: `エクセルファイルに”送り状番号”をすべて入力後、保存します。`,
            tracking_number_guide_05: `3. “エクセルで送り状番号を一度にアップロードする”ボタンからアップロードをする`,
            tracking_number_guide_06: `上のボタンを押して先ほど保存したエクセルファイルをアップロードします。`,
            filter_excel_title: "エクセルで送り状番号を一度にアップロードする",
            filter_excel_tooltip: "配送情報エクセルをまずダウンロードした後、「送り状番号」を入力し、そのファイルをアップロードしてください。",
            seeding_with_commission_title: "PR費用を支給し、より良いインフルエンサーを利用する",
            seeding_with_commission_tooltip: () => (
                <>
                    インフルエンサーに、商品の提供に加え
                    <br />
                    追加で金額を支給する機能です。
                    <br />
                    該当機能は{getServiceName()}担当者が直接対応いたします。
                    <br />
                    ボタンを押したら5分以内にお電話を差し上げます。
                </>
            ),
            order_check_1: "応募者が多い順",
            order_check_2: "キャンペーン作成順",
            fetch_text1: "まだ投稿が完了した商品提供キャンペーンがありません。",
            fetch_text2: "照会されたキャンペーンがありません。",
            product_selected: "インフルエンサー選定完了",
            product_selection_started_title: "インフルエンサー選定期間です。",
            product_selection_started_button_1: "インフルエンサーを選定する",
            product_posting_started_title: "投稿作成およびアップロード期間",
            product_seeding_pass_1:
                "無制限利用によって作成されたキャンペーンです。",
            campaign_with_commissions: "PR費用支給キャンペーン",
            product_apply_commissions: "PR費用を支給する",
            product_apply_commissions_applied: "PR費用の支給適用",
            product_apply_commissions_already_applied: "PR費用の支給がすでに適用された商品です。",
            _product_apply_commissions_minimum_amount: (amount: number, currencyText: string) => `PR費用の支給は最低${amount}${currencyText}から可能です。`,
            campaign_form_header_title_1: ({ updateCampaignId }:
                Pick<CampaignFormContextProps, 'updateCampaignId'>) =>
                updateCampaignId ? 'キャンペーン情報修正' : 'キャンペーン情報登録',
            campaign_form_header_title_2: ({ updateCampaignId, categoryId }:
                Pick<CampaignFormContextProps, 'updateCampaignId'>
                & Pick<BrandDto, 'categoryId'>
            ) => {
                switch (categoryId) {
                    case CATEGORY_ID.BEAUTY:
                        return updateCampaignId ? '動画および投稿ガイドライン修正' : '動画および投稿ガイドライン設定'
                    default:
                        return updateCampaignId ? '投稿ガイドライン修正' : '投稿ガイドライン設定'
                }
            },
            campaign_form_header_title_3: ({ updateCampaignId }:
                Pick<CampaignFormContextProps, 'updateCampaignId'>) => 
                updateCampaignId ? '担当者情報修正' : '担当者情報入力',
            campaign_form_header_desc_1: ({ categoryId }:
                Pick<BrandDto, 'categoryId'>) => {
                switch (categoryId) {
                    case CATEGORY_ID.BEAUTY:
                        return <>キャンペーンに参加するインフルエンサーに公開される内容で、<br/>よりクオリティーの高いリール作成のために正確な情報を入力してください。</>;
                    default:
                        return <>キャンペーンに参加するインフルエンサーに公開される内容で、<br/>よりクオリティーの高い投稿のために正確な情報を入力してください。</>;
                }
            },
            campaign_form_header_desc_2: ({ categoryId }:
                Pick<BrandDto, 'categoryId'>) => {
                switch (categoryId) {
                    case CATEGORY_ID.BEAUTY:
                        return <>キャンペーンおよびリール作成状況の共有を受ける<br/>担当者情報を入力してください。</>;
                    default:
                        return <>誤った商品の発送により、インフルエンサーが返送を要請される場合の受取先住所を入力してください。</>;
                }
            },
            campaign_form_past_campaigns_modal_button: '過去のキャンペーン情報を呼び出す',
            campaign_form_past_campaigns_modal_search_placeholder: '商品名検索',
            campaign_form_past_campaigns_modal_campaigns_empty: '作成された内容がありません。',
            campaign_form_past_campaigns_modal_campaign_created_at: (dateText: string) => `キャンペーン(${dateText}作成)`,
            campaign_form_brand_description_field_label: 'ブランドを一文で紹介',
            campaign_form_brand_description_field_placeholder: (n: number) => `入力 (${n}字以内)`,
            campaign_form_products_field_label: '商品情報',
            campaign_form_products_field_desc: (isCategoryFashion: BrandDto['isCategoryFashion']) => isCategoryFashion ? <>セットアップで提供する場合は一度にアップロードしてください。<br />詳細イメージをたくさんアップロードするほどインフルエンサーの選択率が高くなります。</> : null,
            campaign_form_products_field_add_btn: '商品情報を追加する',
            campaign_form_products_field_input_btn: '商品情報を入力する',
            campaign_form_commission_field_label : "PR費用設定",
            campaign_form_commission_field_sub_label: '商品当たりのPR費用',
            campaign_form_commission_field_reference_text_1: 'リールコンテンツ集',
            campaign_form_commission_field_reference_text_2: 'にあるリール動画の平均PR費用は3～4万円のラインです。',
            campaign_form_commission_field_amount: "商品数量",
            campaign_form_commission_field_amount_units: "個",
            campaign_form_commission_field_total: "総PR費用",
            campaign_form_commission_field_description: "決済はキャンペーン作成の最後の段階で行われます。",
            campaign_form_commission_field_increase_max_step_label: 'もう少しクオリティの高いインフルエンサーの応募も合わせて受け付ける',
            campaign_form_commission_field_increase_max_step_sub_label: (moneyText: string) => `${moneyText}より高いキャンペーンにのみ参加する少数のGlovvおすすめインフルエンサーたちが\n今回のキャンペーンにPR費用を引き上げて応募できるようにしてみてください。`,
            campaign_form_commission_field_increase_max_step_option_step_2: (moneyText: string) => `${moneyText}応募者まで受け付ける(本当に実力のある方がどのような方なのか気になります。)`,
            campaign_form_commission_field_increase_max_step_option_step_1: (moneyText: string) => `${moneyText}応募者まで受け付ける(予算は決まっているが一旦受け付けてみます。)`,
            campaign_form_commission_field_increase_max_step_option_step_0: `結構です。(期待していたクオリティに達していなくても受け入れます。)`,
            campaign_form_single_day_posting_field_check: '必ず特定の日時にInstagramへアップロードをしたいです。',
            campaign_form_single_day_posting_field_label: '12월 올영세일 전용 콘텐츠가 필요하신가요?',
            campaign_form_single_day_posting_field_check_comment: '가장 빠르게 진행 시, 모집 시작부터 최단 8일 소요\n\n포스팅 기한 내에 아무 때나 인스타그램에 업로드하는 것이 아니라\n특정 날짜를 지정하고, 반드시 그 날 인스타그램 업로드를 진행하고 싶습니다.',
            campaign_form_inspection_field_label: "事前チェック",
            campaign_form_inspection_field_check: `Instagramにリールアップロード前に事前チェックを行いたいです。`,
            campaign_form_inspection_field_check_comment: `チェック/解除時、入力した日時が初期化されます。`,
            campaign_form_period_field_label: "キャンペーン期間",
            campaign_form_period_field_oliveyoung_warning: (days: number) => `12월 올영세일 시작까지 ${days}일 남았습니다. (11월 30일 (일) ~ 12월 6일 (토))`,
            campaign_form_period_field_oliveyoung_calender_header: '12월 올영세일 : 11.30 (일) - 12.6 (토)',
            campaign_form_recruit_period_field_label: 'インフルエンサー募集期間',
            campaign_form_recruit_period_required_select_starts_at: '募集開始日をまず選択してください。',
            campaign_form_recruit_period_required_select_ends_at: '募集終了日をまず選択してください。',
            campaign_form_selection_period_field_label: 'インフルエンサー選定期間',
            campaign_form_selection_period_required_select_starts_at: 'インフルエンサーの選定開始日をまず選択してください。',
            campaign_form_product_deploy_period_field_label: '商品出庫日',
            campaign_form_product_deploy_period_field_description: '出庫日を守られない場合、インフルエンサーが実施拒否をする場合がございますので、慎重に選択してください。',
            campaign_form_product_deploy_period_field_placeholder: '商品出庫日',
            campaign_form_posting_period_field_label: (category_id, isSingleDayPosting) => {
                switch(category_id){
                    case CATEGORY_ID.BEAUTY:
                        return isSingleDayPosting
                            ? 'リール作成完了およびInstagram投稿日'
                            : 'リール作成完了およびInstagram投稿期限';
                    default:
                        return "投稿作成期間";
                }  
            },                
            campaign_form_posting_period_field_description: (category_id) => {
                switch(category_id){
                case CATEGORY_ID.BEAUTY:
                    return null;
                    // return <>DEPRECATED_クオリティの高いリール作成の為、最低でも週末を1回以上含めるようにしてください。<br /></>;

                default:
                    return <>週末に撮影に最適な場所へ訪れられるよう、最低でも1回以上の週末を含めてください。<br /></>;
                }
            },
            campaign_form_posting_period_field_posting_ends_at_placeholder: (isSingleDayPosting) => {
              return isSingleDayPosting ? 'インスタグラムアップロード日' : '';
            },
            campaign_form_inspection_period_field_label: '事前チェック動画の提出期限',
            campaign_form_inspection_period_field_label_1: 'インフルエンサーの',
            campaign_form_inspection_period_field_label_2: '事前チェック動画',
            campaign_form_inspection_period_field_label_3: 'ファイル',
            campaign_form_inspection_period_field_label_4: '提出期限',
            campaign_form_inspection_period_field_placeholder: '事前チェック動画の提出期限',

            campaign_form_inspection_feedback_period_field_label: '事前チェック動画のフィードバック期限',
            campaign_form_inspection_feedback_period_field_placeholder:'事前チェック動画のフィードバック期限',
            campaign_form_inspection_feedback_period_field_description: () => {
                return (
                    <>  
                      この日の夜24時までにフィードバックのお送りをお願いいたします。
                      <br />
                      期限を過ぎるとフィードバック入力画面は自動的に終了しますのでご注意ください。
                    </>
                );
            },

            campaign_form_delivery_company_field_label: '利用予定宅配業者',
            campaign_form_output_type_field_label: '投稿の種類を選択してください。',
            campaign_form_photo_guidelines_group_name: '写真ガイドライン',
            campaign_form_photo_guidelines_mandatory_photos_label: '必須写真を教えてください。',
            campaign_form_photo_guidelines_mandatory_photos_description: 'コンテンツ作成難易度が高いほど応募者数が減少することがあります。',
            campaign_form_modification_guide: 'インフルエンサー募集開始日の前日まではキャンペーンの修正が可能です。',
            campaign_form_cant_be_update_modal_title: '直接修正が不可能な項目です。',
            campaign_form_cant_be_update_modal_text: '担当者までご連絡をいただければすぐに対応いたします。',
            campaign_form_load_temporary_campaign_modal_title: '仮保存内容を呼び出す',
            campaign_form_load_temporary_campaign_modal_text: '以前仮保存した内容を呼び出しますか',
            campaign_form_load_temporary_campaign_modal_confirm: '呼び出す',
            campaign_form_delete_product_confirm: '該当商品を削除されますか？\r\n削除された商品は復旧できません。',
            campaign_form_is_after_recruit_start: '募集が開始したキャンペーンは修正が不可能です。',
            campaign_form_photo_model_limit_modal_title: '写真最大受領制限',
            campaign_form_photo_model_limit_modal_text: (limit: number) => `写真は${limit}枚を超えることはできません。`,
            campaign_form_photo_model_recommended_modal_text: '必須写真の合計枚数は4枚が適正です。\n写真数が増えるとインフルエンサーの申請率が低くなってしまいます。',
            campaign_form_other_requests_placeholder: '内容',
            campaign_form_partnership_code_field_label: 'パートナーシップ広告コード発行',
            campaign_form_partnership_code_field_required_description: 'リール作成が完了後、"投稿"タブからコードの確認が可能です。',
            campaign_form_need_guideline_rule_field_true: '必要です。',
            campaign_form_need_guideline_rule_field_false: '必要ありません。',
            complete_title: (isUpdate?: boolean) => `${isUpdate ? 'キャンペーンの修正が完了しました！' : 'キャンペーンの作成が完了しました!'}`,
            complete_info_1: "インフルエンサー募集期間",
            complete_info_2: "インフルエンサー選定期間",
            complete_info_3: "提供する商品の出庫日",
            complete_info_4: "インフルエンサーの投稿作成期間",
            complete_info_4_1: "インフルエンサーの投稿作成日",
            create_modal_select_date: `商品の出庫日を選択してください。${"\n"}出庫日を基準として自動で投稿アップロード開始日と終了日の初期費用が入力されます。`,
            create_modal_postingEndsAt: (category_id) => {
              switch(category_id){
                case CATEGORY_ID.BEAUTY:
                  return "リールアップロード終了日をまず選択してください。";
                default:
                  return "投稿アップロード終了日をまず選択してください。";
              }
            },
            create_modal_recruit_immediately_title : '本日から募集を開始しますか？',
            create_modal_recruit_immediately_text : <>
                募集開始日を"本日"と設定されると、<br/>
                キャンペーン開設完了後即時、アプリに表示される為<br/>
                キャンペーンの内容修正は不可能です。</>,
            create_delete_modal_success: "該当商品の削除に成功しました。",
            create_delete_image_confirm: "該当イメージを削除されますか？",
            create_next_step_with_saving: "一時保存後、次へ",
            create_step3_a_title: "返品関連情報",
            create_step3_a_manager_name: "担当者名",
            create_step3_a_manager_name_placeholder: "担当者名を入力してください。",
            create_step3_a_manager_phone: "携帯電話",
            create_step3_a_manager_phone_placeholder: "連絡先を教えてください。",
            create_step3_a_manager_position: "役職",
            create_step3_a_manager_position_placeholder: "役職を入力してください。",
            create_step3_a_desc: "誤った商品の発送により、インフルエンサーが返送を要請される場合の受取先住所を入力してください。,",
            create_step3_a_return_addr: "返品受取り先住所",
            create_step3_a_return_addr_placeholder: "住所を正確に入力してください。",
            create_step3_b_title: "ブランド担当者情報",
            create_step3_b_desc: "キャンペーンおよびリール作成状況などを共有いたします。",
            create_step3_b_notice: (
                <>
                    事前チェックは、確認期限が過ぎるとフィードバック入力画面が自動的に終了します。
                    <br />
                    そのため、期限を超過しないよう通知を受け取ることが非常に重要です。
                    <br />
                    <br />
                    必ず本キャンペーンに関わるすべての担当者情報を入力してください。
                </>
            ),
            create_step3_b_add_manager: "担当者追加 +",
            create_step3_b_reels: "DEPRECATED_リールファイルを受け取るメールアドレス",
            create_step3_b_reels_desc: "DEPRECATED_完成したリールおよび文字入れ前動画ファイルをメールでお送りします。",
            create_step3_b_manager_email: "DEPRECATED_E-mail",
            create_step3_b_manager_email_placeholder: "DEPRECATED_担当者のE-mailを入力してください。",
            create_step3_a_wholesale_manager_name: "社長指名",
            create_step3_a_wholesale_manager_phone: "携帯電話",
            create_step3_a_wholesale_manager_name_placeholder: "社長のお名前を入力してください。",
            create_step3_b_wholesale_title: "社長情報",
            create_step3_a_wholesale_select_manager: "DEPRECATED_社長",
            create_step3_has_inspection_due_dt_modal_tile: <>事前チェックに関する通知を受け取る<br />すべての担当者情報を入力されましたか？</>,
            create_step3_has_inspection_due_dt_modal_notice: (
                <>
                    事前チェックは、確認期限が過ぎると
                    <br />
                    フィードバック入力画面が自動的に終了します。
                    <br />
                    <br />
                    そのため、期限を超過しないよう<br />
                    通知を受け取ることが非常に重要です。
                    <br />
                    <br />
                    必ず本キャンペーンに関わる<br />
                    すべての担当者情報を入力してください。
                </>
            ),
            create_step3_has_inspection_due_dt_modal_cancel_button_text: "未入力の担当者がいます",
            create_step3_has_inspection_due_dt_modal_confirm_button_text: "すべて入力しました",
            _create_payment_text21: (unit: string) => `300件ギフティングしたら1件あたり500${unit}`,
            create_payment_text22: "今決済すると7日間の無料期間を差し上げます。",
            _create_payment_text23: (days) => (
                <>
                    {days}日後に自動決済され、<br />
                    お好きな時に自動決済の中止が可能です,
                </>
            ),
            create_payment_text24: "自動決済後の返金は不可です。",
            create_payment_button_1: "無制限利用する",
            create_payment_button_2: "このまま進行する",
            _create_payment_text31: (days) => `無制限利用券の利用時は、${days}日後に自動決済が行われます。`,
            create_payment_text32: "いつでも中止可能で、決済後の返金は不可です。",
            create_stepTwo_text37: `*カフェでの室内撮影も禁止されます`,
            show_alert_modal_temp_save_fail_title: "仮保存失敗",
            open_example_guideline_button_text: "他ブランドのガイドライン例を見る",
            create_discount_message: "(例)自社サイトで新商品10%割引中",
            create_prohibitions_check_1: "2. 禁止事項が必要な場合はチェックしてください。",
            create_prohibitions_check_2: "3. 禁止事項が必要な場合はチェックしてください。",
            create_photo_form_image_guideline: "4. ブランドで追加するイメージガイドラインがあれば入れてください。(選択)",
            create_photo_form_image_guideline_fashion: "入力されたイメージはインフルエンサーに表示され、同意を受けます。",
            create_text_guidelines: "文言ガイドライン",
            create_mandatory_phrases_prompt: "5. 投稿に必ず入れなければいけない必須文言があれば教えてください",
            create_mandatory_phrases_description: "入力されたメッセージはインフルエンサーに表示されます。",
            create_tag_guidelines: "タグガイドライン",
            create_brand_instagram_prompt: "6. ブランドのInstagram @公式アカウントを教えてください。",
            create_other_brand_tags_prompt: (category_id) => {
                switch(category_id){
                case CATEGORY_ID.BEAUTY:
                return "7. SNSにリールをアップロードする際、他ブランドのタグが入ってもよろしいでしょうか？";
                default:
                return "7. 投稿に他ブランドのタグが入ってもよろしいでしょうか？";
                }  
            },                
            create_sns_tags_prompt: (category_id) => {
                switch(category_id){
                case CATEGORY_ID.BEAUTY:
                return "8. SNSにリールをアップロードする際、一緒に挿入する#ハッシュタグを教えてください。";
                default:
                return "8. SNS投稿時に挿入する#ハッシュタグを教えてください。";
                }
            },
            create_hashtag_location_prompt: "9. ブランドのハッシュタグが入る位置を選択してください。",
            create_advertisement_tag: "10. #PR #提供タグ",
            create_reels_form_guideline: "動画ガイドライン設定",
            create_reels_form_text_guideline: "文言ガイドライン",
            create_reels_form_tag_guideline: "タグ設定",
            create_reels_form_additional_photos: "リールの他に追加写真を受け取る",
            create_reels_form_video_guideline: "動画ガイドラインを教えてください。",
            create_reels_form_image_guideline: "イメージ形式の追加ガイドライン (選択)",
            create_reels_form_image_guideline_fashion: "入力されたイメージはインフルエンサーに表示され、同意を受けます。",
            create_reels_form_image_guideline_beauty: "PPT、PDFのキャプチャー画像、および小さい文字が入っている画像はアップロードしないでください。\n違反した場合は、必ず検収チームからガイドライン修正の依頼が入ります。",
            create_reels_form_image_guideline_beauty_modal_title: "PPT、PDFキャプチャー画像のアップロードは絶対禁止",
            create_reels_form_image_guideline_beauty_modal_description: "PPT、PDFのキャプチャー画像、\nおよび小さい文字が入っている画像はアップロードしないでください。\n\n違反した場合は、必ず検収チームからガイドライン修正の依頼が入ります。",
            create_reels_form_image_upload : 'イメージ＆説明文をアップロード +',
            create_reels_form_image_modify : '画像を差し替える',
            create_reels_form_logo_guideline: "ブランドロゴファイル最大2個 (選択)",
            create_reels_form_logo_guideline_desc: <>ファイルがない場合はインフルエンサーがおかしなフォントでブランド名を入力する可能性が高くなります。<br/>ホワイトロゴのアップロードをよりおすすめします。ブラック（カラー）ロゴも一緒にアップロード可能であればより良いです。</>,
            create_reels_form_logo_guideline_upload: "背景が透明なロゴファイルをアップロード +",
            create_reels_form_emblem_oliveyoung_guideline: "올영세일 엠블럼",
            create_reels_form_emblem_guideline_check: `動画に挿入するとより良いです。`,
            create_reels_form_emblem_guideline_desc: <>インフルエンサーが2つの中から動画に合うロゴを使用します。</>,
            create_reels_form_emblem_guideline_upload: "背景が透明なファイルをアップロード +",
            create_reels_form_at_tag: "ブランドのInstagram公式アカウント",
            create_reels_form_hash_tag: "投稿時に挿入する#ハッシュタグ",
            create_reels_form_additional_photos_2: "リールの他に写真も必要でしょうか？",
            create_reels_form_placeholder_video_guideline: "より具体的に直接的に表現してください。",
            create_reels_form_placeholder_at_tag: "@brand_tag",
            create_reels_form_placeholder_hash_tag: "'#'を除いて文字だけ入力してください。",
            create_reels_form_checkbox_no_additional_photos: "必要ないです。",
            create_reels_form_checkbox_additional_photos: "追加写真が必要です。\n(追加写真を要請するほど難易度が高くなり、応募率に影響を与えます。最大3枚の写真を要請することができます。)",
            create_reels_form_preferred_video_type: "好みの動画タイプ",
            create_reels_form_preferred_video_type_desc: "キャンペーンタイトルが以下のように表示され、\n該当タイプのインフルエンサーが募集されます。",
            create_reels_form_reference: "インフルエンサーへ伝える参考リール動画のURL1個 (選択)",
            create_reels_form_reference_description: "*リール作成の為の参考目的の動画です。",
            create_reels_form_reference_description_title : '上記リール動画の中で特に参考にするべき部分はありますか？(選択)',
            create_reels_form_reference_description_desc : <>あくまでも参考用なのでインフルエンサーへ強制はできかねますが、<br/>具体的に記載いただくほど、より理想に近い動画に仕上がる可能性が高まります。</>,
            create_reels_form_prohibition_beauty_title : `${getServiceName()} 必須ガイドライン`,
            create_reels_form_prohibition_beauty_desc : `インフルエンサーに常に伝えられているGlovvの必須ガイドラインです。`,
            create_reels_form_video_duration : '動画長さの最低秒数',
            create_reels_form_outputs : '必須シーン',
            create_reels_form_subtitle : '字幕内容入力',
            create_reels_form_subtitle_opening_placeholder : '(例) Qoo10ランキング1位の大人気商品',
            create_reels_form_subtitle_middle_placeholder : '(例)抗酸化成分が豊富な緑茶抽出物使用',
            create_reels_form_subtitle_closing_desc : 'この内容は字幕ではなく、投稿本文（キャプション文）の内容として入力していただければ幸いです。',
            create_reels_form_subtitle_closing_placeholder : '(例)Qoo10で20%割引中',
            create_reels_form_contents: "投稿文内容入力",
            create_reels_form_video_clean_title : "文字入れ前動画要請",
            create_reels_form_video_clean_download_desc : `リール投稿完了後、"投稿"メニューから無料で文字入れ前動画のダウンロードが可能です。`,
            create_reels_form_video_clean_price_desc : "deprecated_気に入った動画だけを選択してダウンロードが可能で、1件あたり1万円が請求されます。",
            create_reels_form_co_author_title : "共同投稿者を追加",
            
            create_reels_form_co_author_announcement_title : "重要なお知らせ",
            create_reels_form_co_author_announcement_desc: `インフルエンサーがInstagramにアップロードをしたとしても、すぐに共同投稿者として表示されるわけではありません。必ずインフルエンサーからの共同投稿者招待に承認を押してください。`,
            create_reels_form_co_author_desc : "インフルエンサーが共同投稿者に追加するInstagramのアカウント",
            create_reels_form_placeholder_co_author : '‘@’を除いて文字のみ入力',
            create_reels_form_load_contents_from_subtitles : '字幕に入れていた内容をそのまま呼び出す',
            create_reels_form_beauty_terms_title : '必須同意項目',
            create_reels_form_beauty_terms_agree : '下記内容に同意します。',
            create_reels_form_beauty_terms : <>ガイドラインを違反した場合でなければ<br/>
            インフルエンサーに修正要請をすることはできません。<br/>
            <br/>
            ただし、事前チェック機能を利用される場合には<br/>
            再撮影を除いた字幕・フォントなどの修正要請が可能です。<br/>
            <br/>
            ブランドからのフィードバックが反映されたかをGlovv検収チームで確認後、ブランドが設定した"リール投稿作成期間"内に自由にアップロードするよう要請いたします。<br/>
            <br/>
            したがってしっかり言及されたい内容がある場合は、ガイドラインにしっかりと盛り込んでいただき、<br/>
            インフルエンサーを選定する際には、普段のリールスタイルや作成能力を必ず確認してください。</>,
            _create_max_length_indicator: (current:number, maximum:number)=>(
                `(${current}/${maximum} ${maximum}文字以内)`
            ),
            create_reels_form_warning_multiple_url: "参考にするリールURLは1つだけ入力してください。",
            create_reels_form_warning_multiple_url_desc: "一番ブランドの理想に近い雰囲気の\nリールURLを1つだけ入力してください。",
            create_reels_form_warning_document: "ブランドが直接作成した自作ガイドラインは\n使用されないようご案内しております。",
            create_reels_form_warning_document_desc: "Glovvを通してガイドラインを作成せず、\nブランド自作のガイドラインをアップロードしてしまうと\n\n統計上インフルエンサーの応募率が30%以上減少し、\nリール作成時に問題が発生する可能性が2倍以上高くなります。",
            create_reels_form_warning_sns_injection: "参考にするリールは1つで十分です。",
            create_reels_form_warning_sns_injection_desc: "参考にするリールを2つ以上入れてしまうと、\nインフルエンサーが逆に混乱してしまう可能性がございます。",
            create_reels_form_before_after_label_for_japan: "使用前/使用後カット",
            intro_backup_modal_use_pc: `PCの商品提供タブから${"\n"}開設をお願いいたします。`,
            intro_backup_text_1: "商品提供キャンペーン🥕",
            _intro_backup_text_2: () => (
                <>
                    👀たった2,000円で ※税別 <b>直接インフルエンサーも選定</b>,
                    <br />
                    月3万円で ※税別<b>無制限で</b>ギフティングできる？
                </>
            ),
            _intro_backup_text_3: () => (
                <>
                    インフルエンサーに商品を提供して、
                    <br />
                    本当に望む
                    <br />
                    SNS投稿を作成してください。
                </>
            ),
            intro_backup_text_4: "3分で開設完了！",
            intro_backup_text_5: "商品提供キャンペーン開設",
            _intro_backup_text_6: () => (
                <>
                    商品提供キャンペーン、
                    <br />
                    どのように進行されますか？
                </>
            ),
            intro_backup_text_7: "*基本料金:1個あたり2,000円(無制限:月3万円)※税抜",
            intro_backup_text_8: "商品提供キャンペーン開設",
            _intro_backup_text_9: () => (
                <>
                    ブランドが気に入る
                    <br />
                    クオリティーの投稿アップロードが完了！✨
                </>
            ),
            intro_backup_text_10: "インフルエンサー応募",
            intro_backup_text_11: `${getServiceName()}インフルエンサー`,
            intro_backup_text_12: "一番気に入ったインフルエンサーを選定",
            intro_backup_text_13: "投稿作成",
            intro_backup_text_14: `${getServiceName()}インフルエンサー`,
            intro_backup_text_15: "インフルエンサーへのコンタクト、難しかったですよね？",
            _intro_backup_text_16: () => (
                <>
                    <b className="text-[#ED8E00]">1,500名</b>のインフルエンサーを
                    <br className="hidden md:flex" />
                    私たちが集めます
                </>
            ),
            intro_backup_text_17: "様々な写真複数枚とリールも撮影します！",
            intro_backup_text_18: "私は投稿5枚+リールも撮影できます！",
            intro_backup_text_19: "今回パリ旅行に行くので、エッフェル塔の前で撮ります！",
            intro_backup_text_20: "つまらない投稿1つはもう終了。",
            _intro_backup_text_21: () => (
                <>
                    インフルエンサーが
                    <br />
                    <b className="text-[#ED8E00]">直接アピール</b>します
                </>
            ),
            intro_backup_text_22: "お望みのインフルエンサーがいませんか？",
            _intro_backup_text_23: () => (
                <>
                    お好きなインフルエンサーを
                    <br />
                    <b className="text-[#ED8E00]">選択してください</b>
                </>
            ),
            _intro_backup_text_24: () => (
                <>
                    今すぐに
                    <br />
                    キャンペーンを開設してみてください！
                </>
            ),
            intro_backup_text_25: "3分で開設完了！",
            intro_backup_text_26: "商品提供キャンペーンを開設する",
            intro_text_3: "クオリティーの高いコンテンツを作成します。",
            intro_text_4: "紹介書ダウンロード",
            intro_text_5: "Check Point 1",
            intro_text_9: "1. SNSで潜在顧客を確保",
            intro_text_10: "2. 顧客が共感する購入転換率を上昇",
            intro_text_11: "売上増加",
            intro_text_12: "Check Point 2",
            intro_text_13: "5分で終わる超簡単3ステップでギフティング",
            intro_text_14: "ギフティング業務を全て自動化しました。",
            intro_text_15: "Check Point 3",
            intro_text_16: "作成されたコンテンツMusinsa snapなどにない単語10",
            intro_text_17: "無制限2次利用",
            intro_text_18: "MUSINSA snap, 広告, 自社モール、Instagram など ない単語11",
            intro_text_19: "お好きなところに自由に使用",
            intro_text_20: "Check Point 4",
            intro_text_22: "フェミニン/カジュアル/セクシー/ゴルフなど",
            intro_text_23: "多様なスタイルのインフルエンサー",
            intro_text_24: "Check Point 5",
            intro_text_25: "お好きなインフルエンサーの選択可能",
            intro_text_26: "4,000名のインフルエンサーのうち ない単語12",
            intro_text_27: "自社のブランドイメージに合うインフルエンサーを選択可能",
            intro_text_28: "Check Point 6",
            intro_text_29: "精巧なガイドラインの設定が可能",
            intro_text_30: "投稿の満足度上昇",
            intro_text_31: "これまで行ってきたギフティングと一目で比較",
            _intro_text_32: (unit: string) => `100件進行時、1件あたり300${unit}で進行可能`,
            intro_text_33: () => (
                <>
                    インフルエンサーに商品を提供し
                    <br />
                    コンテンツを作成してください
                </>
            ),
            intro_text_34: () => (
                <>
                    {`大型ファッションブランドの`}
                    <br />
                    {`高いギフティング現況`}
                </>
            ),
            intro_text_35: () => (
                <>
                    {`Musinsaおよび上位20位ブランドは ない単語13 `}
                    <br className="flex md:hidden" />
                    {`毎月100-300件ギフティングをしてます。`}
                </>
            ),
            intro_text_36: () => (
                <>
                    {`5分あれば終了する`}
                    <br />
                    {`奇跡の商品提供プロセス`}
                </>
            ),
            intro_text_37: `商品提供システムを効率的に革新化させました。`,
            intro_text_38: () => (
                <>
                    {`4,000名のインフルエンサーと ない単語14`}
                    <br />
                    {`共にしています`}
                </>
            ),
            intro_text_39: () => (
                <>
                    {`フェミニン/カジュアル/セクシー/ゴルフなど`}
                    <br className="flex md:hidden" />
                    {`スタイルが多様です。`}
                </>
            ),
            intro_text_40: () => (
                <>
                    {`お望みのインフルエンサーにだけ`}
                    <br />
                    {`商品提供をしてください`}
                </>
            ),
            intro_text_41: () => (
                <>
                    {`4,000名のインフルエンサーのうち、`}
                    <br className="flex md:hidden" />
                    {`自社ブランドのイメージに合うインフルエンサーの選択が可能です。`}
                </>
            ),
            intro_text_42: () => (
                <>
                    {`精巧なガイドラインを`}
                    <br />
                    {`設定してください`}
                </>
            ),
            intro_text_43: `ブランドが直接ガイドラインを設定することができます。`,
            intro_text_44: () => (
                <>
                    {`コンテンツの2次利用は`}
                    <br />
                    {`無制限無料`}
                </>
            ),
            intro_text_45: () => (
                <>
                    {`お望みの用途で期間の制限なし、`}
                    <br className="flex md:hidden" />
                    {`無料で利用できます。`}
                </>
            ),
            intro_text_46: () => (
                <>
                    {`400+個　ない単語15`}
                    <br />
                    {`ブランドが利用中`}
                </>
            ),
            intro_text_47: `高い満足度と離脱率の低さを見せています。`,
            payments_bills_text_1: "自動決済を中止する",
            _payments_cancel_complete_text_1: () => (
                <>
                    商品提供 無制限利用券
                    <br />
                    自動決済が中止されました。
                </>
            ),
            _payments_cancel_complete_text_2: () => (
                <>
                    商品提供の無制限利用券を再購入をご希望の場合は、
                    <br />
                    <b>上段メニュー[商品提供]</b>を押して利用してください。
                </>
            ),
            _payments_cancel_confirm_text_1: (over_days: number, last_date: string) => (
                <>
                    {`現在作成されたキャンペーンがギフティングパスの利用期間を`}
                    {over_days}日超過するので、
                    <br />
                    {over_days}一致代金分を支払ってキャンセルを行います。
                    <br />
                    <br />
                    中止時{last_date}
                    まで使用が可能です。
                    <br />
                </>
            ),
            _payments_cancel_confirm_text_2: (date: string) => (
                <>
                    中止時{date}
                    まで使用が可能です。
                </>
            ),
            payments_cancel_confirm_text_3: "自動決済を中止する",
            _payments_cancel_confirm_text_4: (unit: string) => (
                <>
                    DEPRECATED_自動決済を中止すると、利用券満了日以降に商品提供を利用する場合<br />
                    商品の個数あたり2,000{unit}が賦課されます。
                </>
            ),
            _payments_cancel_confirm_text_5: () => (
                <>
                    今後キャンペーン作成時、投稿期限日がこの日を超過する<br />
                    ことはできません。
                </>
            ),
            payments_cancel_confirm_text_6: "このまま維持する",
            payments_cancel_confirm_text_7: "自動決済を中止する",
            payments_text_1: "決済内訳がありません。",
            _payments_text_2: (date: number, days:number) => (<>{date}日に{days}日後の自動決済について同意をされました。決済後の返金は不可です。</>),
            payments_text_3: "購入分類",
            payments_text_4: `1ヶ月の利用期間は"最初のキャンペーン生成日～最後のキャンペーンの投稿期限日"までです。`,
            select_text_1: "商品を提供するインフルエンサーを選択してください。",
            _select_text_2: (n: number) => `最大${n}名のインフルエンサーを選択することができます。`,
            select_text_3: "要請が進行中です。",
            select_text_4: "インフルエンサーの選定が完了しました。",
            select_text_5: <>選定されたインフルエンサーに商品を発送し<br/>送り状番号を入力してください。</>,
            select_text_6: "選択完了後は変更ができないので慎重に選んでください。",
            select_text_7: "選択完了する",
            show_text_1: "最新順",
            show_text_2: "評点順",
            show_text_3: "フォロワー順",
            show_text_4: "いいね順",
            show_text_5: "選定したインフルエンサー",
            show_text_6: "応募したインフルエンサー",
            show_text_7: "キャンペーン全体を見る",
            show_text_8: "商品提供投稿ガイドラインを",
            show_text_9: "商品提供リールガイドライン",
            show_text_10: "キャンペーンを修正する",
            show_text_11: "キャンペーの削除をご希望の場合は担当者までご連絡をお願い致します。",
            show_text_12: "投稿ガイドライン",
            show_text_13: "投稿に入れないといけない必須文言",
            show_text_14: "リールに入れないといけない必須文言",
            _show_text_17: () => `*頭から足先が切れていない写真が必須で1カット以上${"\n"}*座った姿勢は不可で正面で立って ${"\n"}*含まない場合「投稿しない」とみなされます。`,
            show_text_18: "商品提供数変更",
            show_text_19: "*インフルエンサー選定完了前のみ商品提供数の変更が可能です。",
            show_text_20: "インフルエンサー募集期間",
            show_text_21: "インフルエンサー選定期間",
            show_text_22: "提供する商品の出庫日",
            show_text_23: "インフルエンサーの投稿作成期間",
            show_text_23_1: "Instagramアップロード日",
            show_text_24: "募集を今すぐ終了し、インフルエンサーを選択する",
            show_text_25: "宅配業者",
            show_text_26: "タグ",
            show_text_27: "ブランドアカウントタグ",
            show_text_28: `自社商品の提供を${'\n'}受けたことのない${'\n'}インフルエンサー${'\n'}だけを見る`,
            show_text_29: `お気に入り${'\n'}したインフル${'\n'}エンサーだけ${'\n'}見る`,
            show_text_30: "最新順",
            show_text_31: "評点順",
            show_text_32: "フォロワー順",
            show_text_33: "いいね順",
            show_text_34: "累積選定順",
            show_text_35: "お気に入り順",
            show_text_36: "インフルエンサーの募集期間ではありません。",
            _show_text_37: (count: number) => `応募したインフルエンサー数: ${count}`,
            show_text_38: "検索条件を変更してください。",
            show_text_39: "投稿のアップロード期間ではありません。",
            show_text_40: "選定するインフルエンサーを選択してください。",
            show_text_41: "インフルエンサーを選定する",
            _show_text_42: () => (
                <>
                    1. インフルエンサーの選定を完了したら中止することはできません。
                    <br /> <br /> 2. 選択したインフルエンサーには必ず商品を配送しないといけません。
                    <br /> <br /> 3. 配送日が遅くなる場合は投稿期限も一緒に伸びます。
                </>
            ),
            show_text_43: "インフルエンサーの選定を進行する",
            show_text_44: "エクセル出力する",
            _show_text_45: () => (
                <>
                    選定完了後の変更は不可能なので<br className="md:hidden" />
                    慎重に選んでください。
                </>
            ),
            show_text_52: "金額を入力してください。",
            show_text_59: "その必須他要請事項",
            show_text_62: "コピーする",
            show_text_68: "ガイドラインを見る",
            show_text_70: "本日",
            _show_text_71: (diffDay: any, type: any) =>
                type === 1 ? -diffDay + "残り日数" : diffDay + "日超過",
            _show_text_72: (deplayAt, offsetText) => (
                <>{`出庫予定日: ${deplayAt} (${offsetText})`}</>
            ),
            show_text_73: "**誤った出庫日時データ**",
            show_text_76: `クオリティーが高い${'\n'}${getServiceName()}おすすめの${'\n'}インフルエンサーだけを見る${'\n'}エンサーだけ見る`,
            show_text_77: "募集期間を1週間延長する",
            show_text_78: "アンバサダー選定順",
            show_text_79: "ブランド再選択順",
            _show_text_80: () => (
                <>
                    商品貸与サービスを利用しているインフルエンサーが<br/>
                    現在何個のブランドでアンバサダーインフルエンサーとして活動中なのかの値を表した指標です。<br/>
                    多数のブランドから支持されているインフルエンサーを選択することで、より満足のいくコンテンツを受け取ってみてください！
                </>
            ),
            _show_text_81: () => (
                <>
                    商品提供サービスを利用中のインフルエンサーが<br/>
                    特定のブランドから商品提供を2回以上受けた回数が何回かという値を表した指標です。<br/>
                    複数のブランドで継続して提供を受けた信頼度のあるインフルエンサーを選択することで、より満足のいくコンテンツを受け取ってみてください！
                </>
            ),
            show_text_82: `カテゴリー フィルター`,
            show_text_83: `私たちのブランドのカテゴリに合わないモデル`,
            _show_text_84: (categoriesText) => `${categoriesText} カテゴリ専門のモデルを除外します。`,
            show_text_85: `該当するモデルがありません。`,
            show_text_86: `アクティブ度順`,
            _show_text_87: () => (
                <>
                  最近の{getServiceName()}アプリ活動履歴があるモデルを優先的に表示します。
                </>
            ),
            show_text_89: `おすすめです！`,
            show_text_90: `おすすめインフルエンサー`,       
            show_text_91: `ビューティーリールの作成レベルが高いことが確認できているインフルエンサーです。`,         
            show_text_92: `一般インフルエンサー`,
            show_text_93: `化粧品を持って写真を撮ること自体は簡単です。そのため、リール作成の経験や動画のクオリティを必ず確認してください。`,       
            show_text_94: `リール作成履歴を必ず確認してください。`,
            show_text_95: `お気に入りしたインフルエンサー`, 
            show_text_96: `お気に入りしたインフルエンサーを全員選定する`,
            _show_text_97: () => `追加の決済が必要です。`,
            _show_text_99: () => `確認ボタンを押すと\n追加決済画面に移動します。`,
            show_text_100: `選定人数を変更する`, 
            show_text_101: `選定人数を減らすには\n担当者までご連絡をお願い致します。`, 
            show_text_102: `決済システム提供業者の関係上、\n選定人数を減らすには、システムチームが\n直接キャンペーンを削除後に再生成しなければならない\n時間のかかる過程が発生してしまいます。\n\nこのような理由により、ご不便をお掛けいたしますが\n担当者までご連絡をお願い致します。`, 
            show_text_103: "募集終了まで",
            show_text_104: "募集を今すぐ終了し、インフルエンサーを選択する",
            show_text_105: `事前チェック動画の提出期限`,
            show_text_107: "参考にするリール動画例の説明",
            show_text_108: `復元できません。\n本当に削除しますか？`,
            show_text_109: `PR費用引き上げ応募をしたおすすめインフルエンサー`,
            show_text_110: `事前チェック動画のフィードバック期限`,
            _show_text_110: (moneyText:string) => `普段は${moneyText}以上のPRキャンペーンを中心に進行しているインフルエンサーです。`,
            show_text_brand_liked_influencers: "保存したインフルエンサー",
            show_text_brand_with_product_liked_influencers: "いいね！したインフルエンサー",
            show_text_brand_never_selected_influencers: "選定したことのないインフルエンサー",
            show_text_brand_previously_selected_influencers: "以前選定したインフルエンサー",
            show_text_sort_by_brand_liked_influencers_date: "保存日順",
            show_text_new_influencers: "新入りインフルエンサー",
            update_text_1: "募集を今すぐ終了し、インフルエンサーを選択する",
            update_text_2: "募集が終了した商品",
            update_text_3: "提供する商品の出庫日",
            _update_text_4: () => (
                <>
                    提供する商品を出庫する日を選択してください。
                    <br />
                    出庫日に商品未発送時、ブランド不満足につながるので
                    <br />
                    投稿期間が延長されます。
                </>
            ),
            update_text_5: "商品出庫日",
            update_text_6: "投稿アップロード日",
            _update_text_7: () => (
                <>
                    インフルエンサーが投稿をアップロードする期間です。
                    <br />
                    インフルエンサーがキャンペーン応募時、投稿アップロード日に同意して応募したという
                    <br />
                    ことなのでこの日は変えられません。
                </>
            ),
            update_text_8: "投稿開始日",
            update_text_9: "投稿終了日",
            update_text_10: "完了し、インフルエンサーを選択しに行く",
            _intro_common_text_1: () => (
                <>
                    インフルエンサーに商品を提供し
                    <br />
                    コンテンツを作成してみてください
                </>
            ),
            extend_text_1: "募集期間を1週間延長する",
            _extend_text_2: () => (
            <>
            インフルエンサーの投稿作成期間を含め
            <br />
            すべての期間が1週間ずつ延長されます。
            <br />
            <br />
            延長はキャンペーンあたり1回のみ可能で、
            <br />
            延長後に中止することはできません。
            <br/>
            延長はキャンペーンあたり1回のみ可能で、<br/>
            延長後に中止することはできません。<br/>
            </>
            ),
            extend_text_3: "延長後のインフルエンサー募集期間",
            extend_text_4: "延長後のインフルエンサー選定期間",
            extend_text_5: "延長後に提供する商品出庫日時",
            extend_text_6: "延長後にインフルエンサーの投稿作成期間",
            extend_text_7: "延長する",
            intro_common_text_2: "クオリティーの高い商品を作成いたします。",
            intro_common_text_3: "紹介書ダウンロード",
            intro_common_text_4: "はじめる",
            _intro_common_text_5: () => (
                <>
                    {`知名度のあるブランドは`}
                    <br />
                    {`既に${getServiceName()}を利用いただいています`}
                </>
            ),
            _intro_common_text_6: () => (
                <>
                    {`${getServiceName()}を通して継続してコンテンツを生産しています。`}
                    {/* -- */}
                    {/* -- */}
                </>
            ),
            _intro_common_text_7: () => (
                <>
                    {`たった5分で完了する`}
                    <br />
                    {`奇跡の商品提供プロセス`}
                </>
            ),
            intro_common_text_8: "商品提供システムの超効率化に成功しました",
            _intro_common_text_9: () => (
                <>
                    {`500名のインフルエンサーが`}
                    <br />
                    {`利用しています`}
                </>
            ),
            _intro_common_text_10: () => (
                <>
                    {`フェミニン/カジュアル/ストリートなど、`}
                    <br className="flex md:hidden" />
                    {`スタイルが多様です。`}
                </>
            ),
            _intro_common_text_11: () => (
                <>
                    {`お望みのインフルエンサーにだけ`}
                    <br />
                    {`商品を提供してください`}
                </>
            ),
            _intro_common_text_12: () => (
                <>
                    {`500名のインフルエンサーのうち、`}
                    <br className="flex md:hidden" />
                    {`自社のブランドイメージに合うインフルエンサーの選択が可能です。`}
                </>
            ),
            _intro_common_text_13: () => (
                <>
                    {`詳細なガイドラインを`}
                    <br />
                    {`設定してください`}
                </>
            ),
            intro_common_text_14: "ブランドが直接ガイドラインを設定することができます。",
            _intro_common_text_15: () => (
                <>
                    {`コンテンツの2次利用は`}
                    <br />
                    {`無制限無料`}
                </>
            ),
            _intro_common_text_16: () => (
                <>
                    {`お望みの用途で期間の制限なし・無料で`}
                    <br className="flex md:hidden" />
                    {`利用することができます。`}
                </>
            ),
            _intro_common_text_17: () => (
                <>
                    {`400+個`}
                    <br />
                    {`ブランドが利用中`}
                </>
            ),
            intro_common_text_18: "高い満足度により、とても低い離脱率になっています。",
            intro_common_text_19: "紹介書ダウンロード",
            intro_common_text_20: "はじめる",
            _intro_wholesale_text_1: () => (
                <>
                    {`인플루언서 사진으로 신상마켓 ない単語`}
                    <br className="flex md:hidden" />
                    {`着飾って`}
                    <br className="hidden md:flex" />
                    {`売上を一気に上げてください`}
                </>
            ),
            intro_wholesale_text_2: "インフルエンサーコンテンツ制作代行サービス",
            intro_wholesale_text_3: "LOOKBOOKを見る",
            intro_wholesale_text_4: "はじめる",
            _intro_wholesale_text_5: () => (
                <>
                    {`신상마켓에 이런 사진 올리면　ない単語`}
                    <br />
                    {`売上は当然上がらないでしょう`}
                </>
            ),
            intro_wholesale_text_6: "写真のクオリティーで競争力を備えておく必要があります。",
            _intro_wholesale_text_7: () => (
                <>
                    {`인플루언서가 사장님네 옷을 입고　ない単語`}
                    <br />
                    {`写真を撮影します`}
                </>
            ),
            intro_wholesale_text_8: "신상마켓에 사용해서 매출 확 올려보세요.　ない単語",
            _intro_wholesale_text_9: () => (
                <>
                    {`신상마켓에 활용해서　ない単語`}
                    <br />
                    {`매출 올리세요　ない単語`}
                </>
            ),
            intro_wholesale_text_10: "高クオリティーの写真でクリック率を高め売上を上げてください。",
            _intro_wholesale_text_11: () => (
                <>
                    {`5分あれば終了する`}
                    <br />
                    {`超簡単3ステップ商品提供`}
                </>
            ),
            intro_wholesale_text_12: "商品提供システムを究極の効率に革新化させました。",
            _intro_wholesale_text_13: () => (
                <>
                    {`4천명의 인플루언서와　ない単語 `}
                    <br />
                    {`共にしています`}
                </>
            ),
            _intro_wholesale_text_14: () => (
                <>
                    {`フェミニン/カジュアル/セクシー/ゴルフなど`}
                    <br className="flex md:hidden" />
                    {`スタイルが多様です。`}
                </>
            ),
            _intro_wholesale_text_15: () => (
                <>
                    {`お望みのモデルにだけ`}
                    <br />
                    {`商品を提供してください`}
                </>
            ),
            _intro_wholesale_text_16: () => (
                <>
                    {`4천명의 모델 중 ない単語`}
                    <br className="flex md:hidden" />
                    {`自社ブランドのイメージに合うインフルエンサーを選択することが可能です。`}
                </>
            ),
            _intro_wholesale_text_17: () => (
                <>
                    {`精巧なガイドライン`}
                    <br />
                    {`設定してください`}
                </>
            ),
            intro_wholesale_text_18: "ブランドが直接ガイドラインを設定することができます。",
            _intro_wholesale_text_19: () => (
                <>
                    {`いつでも無料で`}
                    <br />
                    {`原本ダウンロード可能`}
                </>
            ),
            _intro_wholesale_text_20: () => (
                <>
                    {`ブランド管理者ページで`}
                    <br className="flex md:hidden" />
                    {`いつでも原本のダウンロードが可能です。`}
                </>
            ),
            _intro_wholesale_text_21: (unit: string) => (
                <>
                    {`100件進行時`}
                    <br />
                    {`1件当たり300${unit}で作成可能`}
                </>
            ),
            intro_wholesale_text_22: "お望みの料金プランで進行することができます。",
            intro_wholesale_text_23: "LOOKBOOKを見る",
            intro_wholesale_text_24: "はじめる",
            store_contact_msg: "提供+手数料利用問い合わせ",

            apply_commission_modal_quantity_unit : '個',
            apply_commission_modal_text_1 : '現金を提供してよりクオリティーの高い',
            apply_commission_modal_text_2 : 'インフルエンサーを募集します。',
            apply_commission_modal_text_3 : '数量',
            apply_commission_modal_text_4 : 'PR費',
            _apply_commission_modal_text_5 : (unit: string)=> `* リール・Tシャツ・アンダーウェアの場合、${'\n'}最低5,000${unit}～をおすすめします。`,
            apply_commission_modal_text_6 : '* 決済後、お望みのインフルエンサーがいない場合には即時返金いたします。',
            apply_commission_modal_text_7 : '今すぐ決済する',
            _apply_commission_modal_text_8 : (unit: string) => unit,
            apply_commission_modal_text_9 : '決済金額 総額',
            _select_commission_label: (commissionPrice:number, currencySuffix:string) => {
              return `${commissionPrice / 10000}万${currencySuffix}`
            },
            select_commission_reference_url_label: `リールコンテンツ集`,
            select_commission_options: (brand: SelectCommissionProps['brand'], currencySuffix: string) => {
              const commissionOptions = getCampaignCommissionOptions(brand);
              return commissionOptions.map((commissionOption) => {
                return {
                  label: `${commissionOption.commission / 10000}万${currencySuffix}`,
                  value: commissionOption.commission,
                  maxStep: commissionOption.maxStep,
                }
              })
            },
            hidden_influencers_text: () => (
                <>現在、他のキャンペーンの期限切れの問題により、新しいキャンペーンへの応募ができなくなったため、<b>応募者リストから除外されたインフルエンサー</b>がいます。</>
              ),
            only_this_campaign_liked_influencers_text: () => (
                <b>· このキャンペーンのみで「お気に入り」にしたインフルエンサー ：</b>
              ),
            saved_influencers_text: () => (
                <b>· 保存しておいたインフルエンサー：</b>
              ),
             normal_influencers_desc: () => (
                <>
                  {'投稿ごとのクオリティにばらつきが大きく、期限やガイドラインの遵守が確認されていないインフルエンサーです。'}
                  <br/>
                  {'化粧品を持って写真を撮ることはとても簡単です。必ずリール動画の制作経験とスキルがあるかを確認してください。'}
                </>
            ),
            brand_request_recruiting_campaign_application_btn_text: "私たちのキャンペーンに応募するようお願いする",          
            brand_request_recruiting_campaign_application_modal_success_title: "依頼申請完了",
            brand_request_recruiting_campaign_application_modal_success_text: "Glovvの担当者が間もなくご連絡いたします。",
            brand_request_recruiting_campaign_application_modal_title: "募集中のキャンペーンへの応募をお願い",
            brand_request_recruiting_campaign_application_modal_text: (name) => `${name} インフルエンサーに弊社のキャンペーンへの応募をお願いしたいですか？\nGlovvが間に入ってコミュニケーションをサポートいたします。`,          
            brand_request_recruiting_campaign_application_modal_phone_label: '担当者様の携帯電話',
        },
        cards: {
            create_types_1: "一般",
            create_types_2: "個人事業者",
            create_types_3: "법인개별 ない単語17",
            create_types_4: "법인공용 ない単語18",
            create_text_1: "カード情報を全て入力してください。",
            create_text_2: "법인개별: 本人の 名前が 記載されています。ない単語19",
            create_text_3: "법인공용: 会社名が 記載されています。ない単語20",
            create_text_4: "携帯電話",
            create_text_5: "カード番号",
            create_text_6: "有効期間 (MM/YY)",
            create_text_7: "パスワード 前2文字",
            create_text_8: "事業者登録番号 10文字",
            create_text_9: "주민등록번호 앞 6자리　ない単語21",
            create_text_10: "カード所有者名",
            create_text_11: "登録する",
            create_text_12: "Eメール",
            create_text_13: "カード番号が正しくありません",
            create_text_14: "有効期限が正しくありません",
            create_text_15: "セキュリティコードが正しくありません",
            index_text_1: "登録されたカードがありません。",
            index_text_2: "カード登録する",
            index_text_3: "決済カードを変更する",
            index_text_4: "決済カードを登録する",
        },
        charts: {
            approved_at_text_1: "インフルエンサーの承認された期間を選択してください。",
            approved_at_text_2: "クローゼットに入れた商品数",
            _approved_at_text_3: (n: number | string) => `該当使用者数:${n}名`,
            _approved_at_text_4: (weeks: number) => `最後にカートに入れた週(最大${weeks}週)`,
            approved_at_text_5: "貸与した商品数",
            _approved_at_text_6: (n: number | string) => `該当インフルエンサー数:${n}名`,
            _approved_at_text_7: (weeks: number) => `最後に貸与申請した週(最大${weeks}週)`,
            approved_at_text_8: "貸与するを押した数",
            approved_at_text_9: "現時点の全インフルエンサー数",
            approved_at_text_10: "1ヵ月間1回でも貸与したインフルエンサー数",
            approved_at_text_11: "2ヵ月間1回でも貸与したインフルエンサー数",
            approved_at_text_12: "3ヶ月間1回でも貸与したインフルエンサー数",
            _approved_at_text_13: (dateFrom: string, dateTo: string) => `${dateFrom}から${dateTo}に`,
            approved_at_text_14: "承認されたインフルエンサーの活動内訳 統計",
            approved_at_text_15: "インフルエンサー承認期間 選択",
            weekly_text_1: "1週目",
            weekly_text_2: "2週目",
            weekly_text_3: "3週目",
            weekly_text_4: "4週目",
            weekly_text_5: "5週目",
            weekly_text_6: "6週目",
            weekly_text_7: "7週目",
            weekly_text_8: "8週目",
            weekly_text_9: "9週目",
            weekly_text_10: "10週目",
            weekly_text_11: "チャート情報を呼び出しましたが失敗しました。",
            _weekly_text_12: (weeks_ago: number, n: number | string) => `${weeks_ago}週前 - ${n}名`,
            weekly_text_13: "クローゼットに入れた数",
            _weekly_text_14: (weeks: number) => `インフルエンサー承認後${weeks}週が経過した会員数`,
            _weekly_text_15: (weeks: number) => `全てのインフルエンサーの初期 ${weeks}週間インフルエンサー活動チャート`,
            weekly_text_16: "インフルエンサー承認後 結果1週",
        },
        emergency: {
            _products_filter_1: () => `全体${"\n"} `,
            _products_filter_2: () => `完了した${"\n"}ものだけ見る`,
            _products_filter_3: () => `完了${"\n"}していないものだけ見る`,
            _products_filter_4: () => `追加された${"\n"}ものだけ見る`,
            _products_filter_5: () => `追加${"\n"}されていないものだけ見る`,
            products_text_1: "ブランド - 投稿",
            products_text_2: "サイズ情報を呼び出しましたが失敗しました。",
            products_text_3: "商品の作成に成功しました。",
            products_text_4: "該当商品情報を隠しますか？",
            products_text_5: "該当商品を隠しました。",
            products_text_6: "該当商品情報を修正されますか？",
            products_text_7: "該当商品の修正に成功しました。",
            products_text_8: "該当商品情報を削除されますか？",
            _products_text_9: (name: string) => `${name}が削除されました。`,
            products_text_10: "物流復旧",
            products_text_11: "ブランド名",
            products_text_12: "商品情報",
            products_text_13: "隠す",
            _products_text_14: (count: number) => `照会された貸与回数:${count}回`,
            _products_text_15: (sizeName: number, qty: number) => (
                <>
                    {`${sizeName} サイズ/`}
                    {`${qty}着`}
                </>
            ),
            products_text_16: "サイズを選択してください。",
            products_text_17: "数量を選択してください。",
            rentals_text_1: "貸与目録",
            rentals_text_2: "会員名検索",
        },
        help: {
            missions_1_title: "ブランド情報設定",
            missions_1_est: "1分所要",
            missions_1_desc: (category_id) => {

                switch(category_id){
                
                case CATEGORY_ID.BEAUTY:
                
                return "ブランドのロゴをアップロードし、リールをアップロードする際に挿入するタグを設定します。";
                
                default:
                
                return "ブランドのロゴをアップロードし、投稿する際に挿入するタグを設定します。";
                
                }
                
            },                
            missions_2_title: "投稿通知設定",
            missions_2_est: "1分所要",
            missions_2_desc: (category_id) => {
                switch(category_id){
                case CATEGORY_ID.BEAUTY:
                return "ニュースレター、およびリール通知を受け取る連絡先を入力します。";
                default:
                return "ニュースレター、および投稿通知を受け取る連絡先を入力します。";
                }  
            },                
            missions_3_title: "パスワード変更",
            missions_3_est: "30秒所要",
            missions_3_desc: "今後使用するパスワードを設定します。",
            missions_4_title: "商品提供キャンペーン作成",
            missions_4_est: "5分所要",
            missions_4_desc: "商品提供のために、商品情報およびキャンペーン情報を登録します。",
            missions_text_1: "ブランド情報を呼び出せません。",
            missions_text_2: "ご利用ありがとうございます、初めてでしょうか？",
            _missions_text_3: () => (
                <>
                    ご利用ありがとうございます。はじめてでしょうか？
                    <br />
                    下記順序に従ってご入力をお願いいたします！😀
                </>
            ),
            missions_text_4: "完了",
            missions_text_5: "すぐに行く",
            missions_text_6: "初回利用特典",
            missions_text_7: "残り", // 時間. ex)残り2時間
            missions_text_8: "イベントが締め切られました！",
            _missions_text_9: () => (
                <>
                    上記時間内に初回キャンペーンを作成すると、無制限料金制使用の場合、7日の
                    無料期間を差し上げます。
                </>
            ),
            missions_text_10: "✅商品提供キャンペーンの作成、難しくないですか？",
            missions_text_11: "5分で終了！",
            missions_text_12: "キャンペーン情報入力",
            _missions_text_13: () => (
                <>
                    キャンペーン紹介文作成、および商品情報登録
                    <br />
                    インフルエンサー募集/選定日および商品出庫日設定
                </>
            ),
            missions_text_15: "投稿ガイドライン設定",
            missions_text_16: "投稿#タグ設定",
            missions_text_17: "担当者連絡先入力",
            missions_text_18: "決済",
            missions_text_19: "✅どのくらい多くのブランドが商品提供をしていますか？",
            missions_text_20: "200+個ブランド",
            _missions_text_21: () => (
                <>
                    商品提供サービスを利用中のブランドが、いつしか200社を超えました。
                    <br />
                    すべてのブランドが一番望んでいた機能であるゆえ、開始１か月で成し遂げた 成果です。
                </>
            ),
        },
        image: {
            index_text_1: "このイメージをダウンロード",
        },
        invite: {
            intro_text_1: "オフライン招待問い合わせ",
            intro_text_2: "インフルエンサーを招待して",
            intro_text_3: `オフラインでの売上を活性化させてください`,
            intro_text_4: `インフルエンサーがオフライン店舗に訪問し投稿をします。`,
            intro_text_5: "紹介書ダウンロード",
            intro_text_6: `${getServiceName()}担当者に利用問い合わせをする`,
            _intro_text_7: () => (
                <>
                    {`オフラインイベントを`}
                    <br />
                    {`知人たちだけのイベントとして行っていませんか？`}
                    {/* SYNC LINES */}
                    {/* SYNC LINES */}
                </>
            ),
            intro_text_8: `知人たちだけに訪問要請をするのには限界があります。`,
            _intro_text_9: () => (
                <>
                    {`訪問を望むインフルエンサーを`}
                    <br />
                    {`選ぶだけで完了します`}
                </>
            ),
            _intro_text_10: () => (
                <>
                    {`応募したインフルエンサーのうち、自社のイベントに合う人を選んでください。`}
                    {/* SYNC LINES */}
                    {/* SYNC LINES */}
                </>
            ),
            _intro_text_11: () => (
                <>
                    {`たった3分で`}
                    <br />
                    {`インフルエンサーの募集開始`}
                </>
            ),
            intro_text_12: `素早くイベントの参加人員を集めることができます。`,
            _intro_text_13: () => (
                <>
                    {`オフラインに招待することで`}
                    <br />
                    {`得られる効果`}
                </>
            ),
            intro_text_14: `10ブランドのインタビュー平均値です。`,
            
            intro_text_21: "紹介書をダウンロードする",
            intro_text_22: `${getServiceName()}担当者に利用問い合わせ`,
            intro_text_23: "担当者を割り当て中です...",
            intro_text_24: "担当者割り当てが完了しました。",
            intro_text_25: "黒澤 杏香",
            _intro_text_26: (name: string) => (
                <>
                    {name} 担当者様、こんにちは。
                    <br />
                    5分以内に進行いたします。
                    <br />
                    後ほどよろしくお願いいたします！
                </>
            ),
        },
        lookbook: {
            _index_text_1: () => (
                <>
                    {getServiceName()}が作った写真を
                    <br />
                    見てみてください
                </>
            ),
        },
        models: {
            index_tabs_1: "全体",
            index_tabs_2: "밀어주는 모델 ない単語22",
            index_tabs_3: "除外したインフルエンサー",
            _index_text_1: (count: number | string) => `全${count}名のインフルエンサー`,
            index_text_2: "ゴルフインフルエンサーだけ見る",
            index_text_3: "人気インフルエンサーだけ見る",
            index_text_4: "除外したインフルエンサーがいません。",
            index_text_5: "밀어주는 모델이 없어요. ない単語23",
            index_text_6: "人気インフルエンサーを見に行く",
            index_text_7: "밀어주기 ない単語24",
            index_text_8: "除外する",
            index_text_9: "밀어주기 중 ない単語25",
            index_text_10: "除外中",
            intro_text_1: "自社ブランドに合う",
            intro_text_2: "모델을 밀어주세요 ない単語26",
            intro_text_3: "밀어주는 모델이 우리 브랜드 옷을 입고 ない単語27",
            _intro_text_4: (unit: string) => `投稿を完了するごとに3,000${unit}を支払っていただければ大丈夫です。`,
            intro_text_5: "インフルエンサーを見に行く",
        },
        payments: {
            _complete_text_total_price: (price: number | string, amount: number) => `(1個あたり ${price} * ${amount}個)`,
            complete_text_1: "화이트라벨 ない単語28",
            complete_text_2: "商品提供初利用",
            complete_text_3: "商品提供無制限",
            complete_text_4: "商品提供",
            complete_text_5: "自社サイト連動利用",
            complete_text_6: "個",
            complete_text_7: "件",
            complete_text_8: "個数",
            complete_text_9: "費用",
            complete_text_10: "決済完了",
            _complete_text_11: (days) => `${days}日後自動決済に同意されました。`,
            complete_text_12: "設置費用",
            complete_text_13: "最初の1回だけ決済",
            _complete_text_14: (date: string) => `(${date}日に決済が進行されます。)`,
            _complete_text_15: (days: number)=> `${days}日後自動決済予定`,
            complete_text_16: "(VAT10% 別途)",
            complete_text_17: "最終決済金額(VAT10%含む)",
            complete_text_18: "商品提供無制限自動決済活性化",
            complete_text_19: "PR費用 利用金額",
            complete_text_20: "自社サイト連動利用券自動決済活性化",
            complete_text_21: "1件あたりの料金プラン",
            complete_text_22: "1年間無制限料金プラン",
            complete_text_23: "PR費用",
            complete_text_24: "最終追加決済金額(VAT10%含む)",
            complete_text_25: "事前チェック費用",
            complete_text_26: "決済が正常に完了しました。",
            create_text_1: "화이트라벨　ない単語28",
            create_text_2: "商品提供初利用",
            create_text_3: "商品提供無制限",
            create_text_4: "商品提供無制限 自動決済活性化",
            create_text_5: "商品提供",
            create_text_6: "自社サイト連動利用",
            create_text_7: "自社サイト連動利用権 自動決済活性化",
            create_text_8: "個数",
            create_text_9: "費用",
            _create_text_10 : (days: number) => `毎${days}日ごとに自動決済`,
            _create_text_11: () => (
                <>お好きな時に自動決済の中止が可能で、決済後は返金が不可です。</>
            ),
            create_text_12: "無制限利用プランは利用途中での返金が不可能なことに同意します。",
            create_text_13: "決済が進行中です。",
            create_text_14: "自動決済の進行に同意してください。",
            create_text_15: "決済カードを登録してください。",
            create_text_16: "PR費用 利用金額",
            create_text_17: "サービス利用料",
            create_text_18: "商品数量",
            create_text_19: "合計",
            create_text_20: "1件あたりの料金プラン",
            create_text_21: "1年間無制限料金プラン",
            create_text_22: "商品提供1件あたり、サービス利用料が付加されます。",
            create_text_23: "1年間サービス利用料なしでご利用いただけます。",
            create_text_24: "1カ月間サービス利用料なしでご利用いただけます。",
            create_text_25: "無制限利用プラン",
            create_text_26: "PR費用",
            create_text_27: "事前チェック費用",
            create_text_additional_selection_section_title: "追加選定費用",
            create_text_commission_increased_section_title: "PR費用引き上げ応募による追加費用",
            create_text_cash_brand_warning: "** 現金決済のアカウントです。実決済なしで進行されます。 **",
            create_text_clean_video_name: `文字入れ前動画ファイル`,
            create_text_clean_video_subtitle: `文字入れ前動画ダウンロード費用`,
            create_text_clean_video_per_each: `動画あたり`,
            create_text_clean_video_amount_name: `動画数量`,
            create_text_additional: "追加 ",
            create_text_pass_using: "利用中",
            create_text_total_amount: (amount:number) => `総${amount}個`,
            create_text_per_each : "商品あたり",
            index_text_1: "決済内訳がありません。",
            index_text_2: "注文日時",
            index_text_3: "商品",
            index_text_4: "決済状態",
            index_text_5: "金額",
            index_text_6: "サービス利用料",
            index_text_7: "PR費用",
            index_text_8: "（税込金額）",
            index_text_9: "事前チェック費用",
            index_text_10: "PR費用引き上げ",
        },
        postings: {
            index_duration_option_1: "貸与選択",
            index_duration_option_2: "投稿登録",
            index_duration_1: "全体期間",
            index_duration_2: "最近90日",
            index_duration_3: "最近30日",
            index_duration_4: "最近7日",
            index_duration_5: "今月",
            index_duration_6: "先月",
            index_duration_7: "今週",
            index_duration_8: "先週",
            index_text_1: "開始日を入力してください",
            _index_text_2: (year: number, month: number) => `${year}年 ${month}月`,
            _index_text_3: (month: number) => `${month}月 完了した貸与投稿数`,
            _index_text_4: (status1: any, status2: any) => `一般投稿 ${status1} + アンバサダー投稿 ${status2}`,
            _index_text_5: (month: number) => `${month}月 作成中の貸与投稿数`,
            _index_text_6: (month: number) => `${month}月 完了した提供投稿数`,
            _index_text_7: (month: number) => `${month}月 作成中の提供投稿数`,
            index_text_9: "終了日以前の日を選択してください。",
            index_text_10: "開始日以降の日を選択してください。",
            index_text_11: "照会",
            index_text_12: "ダウンロードする投稿がありません。",
            index_text_13: "50個以下の投稿で制限されます。\n期間や条件を制限してください。",
            index_text_14: "検索結果写真のみ一括ダウンロード",
            index_text_15: "さんの投稿", // [name]さんの投稿
            _index_text_16: (keyword: string) => `"${keyword}"の商品検索結果です。`,
            index_text_17: "の投稿", // [name]の投稿
            _index_text_18: (keyword: string) => `"${keyword}"の検索結果`,
            index_text_19: "全体投稿",
            _index_text_20: (n: any) => `${n}個の投稿`,
            index_text_21: "投稿ガイドライン",
            index_text_22: "通知設定",
            index_text_23: "全体",
            index_text_24: "商品提供",
            index_text_25: "商品貸与",
            index_text_26: "他ブランドの投稿を見る",
            index_text_27: "アップデート",
            index_text_28: "화이트라벨 기능 업데이트！ ない単語29",
            index_text_29: (category_id) => {
                switch(category_id){
                case CATEGORY_ID.BEAUTY:
                return "リールが作成されるごとに通知を受けてください";
                default:
                return "投稿が作成されるごとに通知を受けてください";
                }  
            },
            modal_downloader_text_1: "エラーが発生しました。",
            modal_downloader_text_2: "ダウンロードする投稿がありません。",
            _modal_downloader_text_3: (count: number) => `投稿数がとても多いです。(${count}個)`,
            modal_downloader_text_4: `区分: 提供\n`,
            modal_downloader_text_5: `区分: 貸与\n`,
            _modal_downloader_text_6: (date: string) => `開始日: ${date}\n`,
            _modal_downloader_text_7: (date: string) => `終了日: ${date}\n`,
            _modal_downloader_text_8: (name: string) => `インフルエンサー名: ${name}\n`,
            _modal_downloader_text_9: (name: string) => `商品名: ${name}\n`,
            _modal_downloader_text_10: (name: string) => `商品名詳細検索: ${name}\n`,
            _modal_downloader_text_11: (name: string) => `商品名検索: ${name}\n`,
            modal_downloader_text_12: "検索結果写真のみ一括ダウンロード",
            modal_downloader_text_13: "現在の検索条件",
            modal_downloader_text_14: "- 多くのイメージを受け取りました。安定したネットワーク環境下でダウンロードしてください。",
            modal_downloader_text_15: "- 50個を超過する写真を一度にDLすることは、性能上制限されます。期間や条件を絞ってDLしてください。",
            modal_downloader_text_16: "イメージデータ要請中...",
            _modal_downloader_text_17: (progress: string) => `イメージダウンロード中... (${progress}%)`,
            modal_downloader_text_18: `ダウンロード完了。少々お待ちください...`,
            _modal_downloader_text_19: (progress: string) => `圧縮ファイル生産中... (${progress}%)`,
            modal_downloader_text_20: "進行中には中止できません",
        },
        products: {
            status_fl_desc_1: `제품정보 확인 후 이상이 없으면 [제출하기] 버튼을 눌러주세요.`,
            status_fl_desc_2: `입고 제품 검수 후 이상이 없으면 모델들에게 바로 대여가 시작됩니다.`,
            status_fl_desc_4: `오늘룩 모델들에게 정상적으로 대여가 진행 중입니다.`,
            status_fl_desc_5: `오늘룩이 반납요청을 확인할 때까지 조금만 기다려 주세요.`,
            status_fl_desc_6: `반납요청이 확인 완료되었습니다. 준비가 되면 제품을 보내드리겠습니다.`,
            status_fl_desc_7: `오늘룩이 반납 제품을 발송할 예정입니다. 곧 제품을 받으실 수 있습니다.`,
            status_fl_desc_8: `제품 반납이 완료되었습니다.`,
            
            recommand_search_option_1: "全体",
            recommand_search_option_2: "作成中",
            recommand_search_option_3: "検収中",
            recommand_search_option_4: "入庫中",
            recommand_search_option_5: "進行中",
            recommand_search_option_6: "返却要請",
            recommand_search_option_7: "返却要請受付",
            recommand_search_option_8: "返却中",
            recommand_search_option_9: "返却",
            recommand_text_1: "追加入庫を考えてください",
            recommand_text_2: "商品を送る住所",
            recommand_text_3: "コピー完了",
            recommand_text_4: "住所のコピーが完了されました。",
            recommand_text_5: "コピー失敗",
            recommand_text_6: "住所のコピーが制限されました。",
            recommand_text_7: "コピー",
            recommand_text_8: "商品人気順位",
            recommand_text_9: "クリック数 ",
            recommand_text_10: "入庫数量 ",
            recommand_text_11: "(04406) 서울시 용산구 보광로60길 3, 이화빌딩 3층 (010-9635-9152)ない単語30",
            create_master_text_1: "スタイル情報を呼び出しましたが失敗しました。",
            create_master_text_2: "カテゴリー情報を呼び出しましたが失敗しました。",
            create_master_text_3: "再分類",
            create_master_text_4: "サイズ情報を呼び出しましたが失敗しました。",
            create_master_text_5: "商品情報を修正する",
            create_master_text_6: "商品情報を入力する",
            create_master_text_7: `該当イメージを始められますか？\r\n削除されたイメージは復旧できません。`,
            create_master_text_8: "色を削除する",
            create_master_text_8_m: "色削除",
            create_master_text_9: "色名を入力してください。",
            create_master_text_10: "セットアップ衣装の場合はトップスの色で指定してください。",
            create_master_text_11: 
            <>
            この色の
            <br />
            代表イメージ
            </>,
            create_master_text_11_setup: 
            <>
            代表イメージ
            </>,
            _create_master_text_12: () => (
                <>
                    商品のサムネイルとなるイメージをアップロードしてください。
                    <br />
                    正四角形でない場合、余白は切り取られます。
                    <br />
                    容量は5MB以下のイメージを登録してください。
                </>
            ),
            create_master_text_13: "数量を選択してください。",
            create_master_text_14: "親カテゴリーをまず選択してください。",
            create_master_text_15: "サイズ削除する",
            create_master_text_15_m: "サイズ削除",
            create_master_text_16: "靴",
            create_master_text_17: "アンダーウェア",
            create_master_text_18: "インフルエンサーを選定する際、該当インフルエンサーのサイズを表示します。",
            create_master_text_19: "選定したインフルエンサーのサイズに合わせて配送してください。",
            create_master_text_20: "この色の他のサイズを追加する +",
            create_master_text_21: `いくつかの商品をまとめて1つの"セットアップ"として登録をします。`,
            _create_master_text_22: (index: number) => `商品名 ${index}`,
            create_master_text_24: "市場価格",
            create_master_text_25: "(定価)",
            create_master_text_25_jp: "(定価)",
            create_master_text_26: "セットアップ商品を追加する +",
            create_master_text_27: "スタイルを選択してください。",
            create_master_text_28: "親カテゴリー",
            create_master_text_29: "カテゴリーを選択してください。",
            create_master_text_30: "子カテゴリー",
            create_master_text_31: "副資材",
            create_master_text_32: "商品破損/紛失留意事項",
            _create_master_text_33: () => (
                <>
                    貸与の特性上、日常で着用するため、破損または紛失が発生することがあります。これにおいて{getServiceName()}に賠償責任がないことに同意します。
                </>
            ),
            create_master_text_34: "ほかの色を追加する +",
            create_master_text_35: "詳細イメージアップロード",
            _create_master_text_36: ({isVisibleSizeMessage}: {isVisibleSizeMessage?: boolean}) => (
                <>
                    * 縦の長さが10,000px以上のイメージの場合は、数枚に分けてアップロードしてください。(アプリが頻繁に落ちてしまう現象が発生する場合がございます。)
                    {isVisibleSizeMessage && (
                        <>
                            <br />* サイズ情報を必ずアップロードしてください。
                        </>
                    )}
                    <br />* 5MB以下のファイルをアップロードしてください。
                </>
            ),               
            create_master_text_37: "ベルト、ブローチなどの副資材が含まれる場合は記載してください。",
            create_master_text_38: "1個以上の詳細イメージが必要です。先にイメージを追加後に削除してください。",
            create_master_text_39: "サイズを入力してください。",
            create_master_text_40: "サイズ",
            _create_master_text_41: () => (
                <>
                    上/下を合わせて1つの"セットアップ"として登録されると、応募者がはるかに多くなります。
                </>
            ),
            _create_master_text_42: () => (
                <>
                    トップス/ボトムスを合わせて1つの "セットアップ"として登録すると、商品は実際には2点ですが、費用請求は1回となる為、価格上お得になります。
                </>
            ),
            create_master_text_43: "対応していないイメージファイル形式です。",
            create_master_text_44: "画像の縦の長さを10,000px以下に分割してください。",
            create_master_text_45: `ブランドタグ`,
            create_master_text_46: `製品のブランドタグを入力してください。 (オプション)`,
            create_master_text_47: `コツ`,
            create_master_text_48: `基本情報入力`,
            _create_master_text_49: (index: number) => `色情報${index ? `${index + 1} ` : ``}入力`,
            create_master_text_50: <>   
            * 正四角形の比率をおすすめします。
            <br />
            * アプリ画面上でサムネイルイメージとして使用されます。
            <br />
            * 5MB以下のファイルをアップロードしてください。
            </>,
            create_master_text_51: "詳細イメージ",
            create_master_text_52: "色名",
            create_master_text_53: "サイズ",
            create_master_text_54: "(例: 上着 M)",
            create_master_text_55: "代表イメージアップロード",
            create_master_text_56: "数量",
            create_master_text_56_full: "このサイズの数量",
            create_master_text_57: '* ブランド名は含まずに商品名のみ入力してください。',
            index_search_option_1: "全体",
            index_search_option_2: "作成中",
            index_search_option_3: "検収中",
            index_search_option_4: "入庫中",
            index_search_option_5: "進行中",
            index_search_option_6: "返却要請",
            index_search_option_7: "返却要請受付",
            index_search_option_8: "返却中",
            index_search_option_9: "返却",
            index_text_1: "ブランド情報を呼び出せませんでした。",
            index_text_2: "(04406) 서울시 용산구 보광로60길 3, 이화빌딩 3층 (010-9635-9152)ない単語31",
            index_text_3: "コピー完了",
            index_text_4: "コピーが完了しました。",
            index_text_5: "コピー失敗",
            index_text_6: "コピーが制限されました。",
            index_text_7: "(04406) 서울시 용산구 보광로60길 3, 이화빌딩 3층 ない単語32",
            index_text_8: "コピー",
            index_text_9: "入庫された商品数",
            index_text_10: "個",
            index_text_11: "登録は完了したが検収ができていない商品数",
            index_text_12: `${getServiceName()}物流に入庫を完了されたら1~2日以内に検収が完了されます。\n入力された商品情報と実際に入庫された商品が相違した場合、検収が完了されません。`,
            index_text_13: "回収を要請した商品数",
            index_text_14: `${getServiceName()}は回収要請時、最も早い日時に返却します。\n"本日中に送ってください”のような要請は物流状況によっては難しいです。`,
            index_text_15: "現在貸与中の一般インフルエンサー数",
            index_text_16: "名",
            index_text_17: "現在貸与中のアンバサダーインフルエンサー数",
            index_text_18: "人気が高く追加で入庫すると良い商品を確認してみて下さい！",
            index_text_19: "商品情報を入力する",
            index_text_20: "全選択",
            index_text_21: "選択した商品の登録を受付する",
            index_text_22: "選択した商品の返却を申請する",
            index_text_23: "商品名/副資材",
            index_text_24: "全貸与回数",
            index_text_25: "修正/削除",
            index_text_26: `${getServiceName()}へ`,
            index_text_27: "復旧中",
            index_text_28: `該当商品を削除されますか？\r\n削除された商品は復旧できません。`,
            _index_text_29: (name: string) => `${name}の削除に成功しました。`,
            index_text_30: "商品の色/サイズ情報を入力してください。",
            index_text_31: "破損/紛失関連留意事項を見る",
            index_text_32: "結果物",
            index_text_33: "商品破損/紛失留意事項",
            index_text_34: `貸与の特性上、日常で着用するため破損または紛失が発生することがあります。これについて${getServiceName()}に賠償責任がないことに同意します。`,
            index_text_35: "変更されました。",
            index_text_36: "リール投稿はアンバサダーインフルエンサーだけ可能です。",
            index_text_37: "ガイドラインを設定する",
            _index_text_38: (nextTargetName: string) => `${nextTargetName}に変更時必須同意項目`,
            _index_text_39: ({ beforeTargetName, nextTargetName }: any) => `${beforeTargetName}に同意して服を貸与したインフルエンサーがいる場合、${"\n"}該当インフルエンサーは${nextTargetName}に同意しなかったとして${beforeTargetName}をアップロードすることができるということに同意しなければいけません。`,
            index_text_40: "同意します",
            index_text_41: `대여현황`,
            _index_text_42: (qty:number) => `貸与中(${qty})`,
            index_text_43: `投稿`,
            index_text_44: `商品名検索`,
            _index_text_45: (productCount:number) => `‘제출하기’ 가능한 제품만 전부 선택하기 (${productCount})`,
            _index_text_46: (productCount:number) => `‘반납 요청하기’ 가능한 제품만 전부 선택하기 (${productCount})`,
            index_text_47: `제출하기 할 제품을${'\n'}선택하고 계신 것 아니었나요?`,
            index_text_48: `제출하기 할 제품과 반납 요청하기 할 제품은${'\n'}동시에 선택할 수 없습니다.`,
            index_text_49: `반납 요청하기 할 제품을${'\n'}선택하고 계신 것 아니었나요?`,
            index_text_50: `반납 요청하기할 제품과 제출하기할 제품은${'\n'}동시에 선택할 수 없습니다.`,
            index_text_51: `제출하기`,
            index_text_52: `반납 요청하기`,
            index_text_53: `입력한 제품정보 제출하기`,
            index_text_54: `제품 반납 요청하기`,
            index_text_55: `제출하기 완료`,
            index_text_56: `이제 오늘룩 물류센터로 제품을 보내주시면${'\n'}바로 검수 작업을 시작합니다.`,
            index_text_57: `반납 요청하기 완료`,
            index_text_58: `오늘룩이 반납요청을 확인할 때까지${'\n'}조금만 기다려 주세요.`,
            index_text_60: `다른 제품까지 한꺼번에${'\n'}제출하시겠어요?`,
            _index_text_61: (qty:number) => `제출하기 할 수 있는 제품이 ${qty}개 더 있습니다.`,
            index_text_62: `다른 제품까지 한꺼번에${'\n'}반납 요청하시겠어요?`,
            _index_text_63: (qty:number) => `반납 요청하기할 수 있는 제품이 ${qty}개 더 있습니다.`,
            _index_text_64: (selectedQty:number, totalQty:number) => `선택한 제품 제출하기 (${selectedQty}/${totalQty})`,
            _index_text_65: (selectedQty:number, totalQty:number) => `선택한 제품 반납 요청하기 (${selectedQty}/${totalQty})`,
        },
        rental: {
            ambassador_index_text_3: "ブランド情報を呼び出せません。",
            ambassador_index_text_4: "現在準備中の機能です。",
            ambassador_index_text_5: "カード連動を完了してください。",
            ambassador_index_text_6: `一般インフルエンサー利用は有料です。${"\n"}カード連動を完了したら、${"\n"}アンバサダーインフルエンサー利用が可能です。`,
            ambassador_index_text_7: "カード連動する",
            ambassador_index_text_8: "一般インフルエンサー貸与中断",
            ambassador_index_text_9: "一般インフルエンサー貸与開始",
            _ambassador_index_text_10: (count: number) => `現在一般インフルエンサーが ${count}個の商品を貸与中です。${"\n"}アンバサダーインフルエンサー貸与はこの貸与件まで完了するようにします。`,
            ambassador_index_text_11: "一般インフルエンサーを対象にした貸与サービスを活性化します。",
            ambassador_index_text_12: "この決定はインフルエンサーの活動に影響を与えるとても重要な決定です。慎重に進行してください。",
            ambassador_index_text_13: "アンバサダーインフルエンサー投稿ガイドラインをまず設定してください。",
            ambassador_index_text_14: "アンバサダーインフルエンサー投稿ガイドラインをまず設定すると利用が可能です。",
            ambassador_index_text_15: "設定しに行く",
            ambassador_index_text_16: "カード連動を完了してください。",
            ambassador_index_text_17: `アンバサダーインフルエンサー利用は有料です。${"\n"}カード連動を完了すると、${"\n"}アンバサダーインフルエンサー利用が可能です。`,
            ambassador_index_text_18: "アンバサダー貸与中断",
            ambassador_index_text_19: "アンバサダー貸与開始",
            _ambassador_index_text_20: (count: number) => `現在アンバサダーインフルエンサーが${count}個の商品を貸与中です。${"\n"}アンバサダーインフルエンサー貸与はこの貸与件まで完了するようにします。`,
            ambassador_index_text_21: "アンバサダーを対象とした貸与サービスを活性化します。",
            ambassador_index_text_22: "この決定はインフルエンサーの活動に影響を与えるとても重要な決定です。慎重に進行してください。",
            ambassador_index_text_23: "インフルエンサー設定",
            ambassador_index_text_24: "自社の商品を貸与することができるインフルエンサー",
            ambassador_index_text_25: "一般インフルエンサー",
            _ambassador_index_text_26: (unit: string) => `一般インフルエンサーが投稿をするごとに1,500${unit}が賦課されます。(VAT 別途) 価格は安いですがインフルエンサーを直接選択できず、投稿クオリティーがアンバサダーインフルエンサーに比べて少し落ちることがあります。`,
            ambassador_index_text_27: "アンバサダーインフルエンサー",
            _ambassador_index_text_28: (unit: string) => `アンバサダーインフルエンサーが投稿を作成するごとに3,500${unit}が賦課され(VAT 別途)、このうち2,000${unit}がインフルエンサーに支給されます。インフルエンサーを直接選択できる機能が提供され、ガイドライン設定が可能です。投稿クオリティーが一般インフルエンサーより高いことが期待できます。`,
            ambassador_index_text_29: "ブランドの80%が利用中",
            ambassador_index_text_30: "1名が1ヶ月に着用可能な最大商品数",
            ambassador_index_text_31: "アンバサダーインフルエンサー応募者通知受け取り",
            ambassador_index_text_32: "通知受け取り",
            ambassador_index_text_33: "アンバサダーインフルエンサー投稿ガイドライン",
            ambassador_index_text_34: "設定する",
            ambassador_index_text_35: "アンバサダーインフルエンサー応募者",
            ambassador_index_text_36: "アンバサダーインフルエンサー",
            ambassador_index_text_37: "選定が完了されました。",
            ambassador_index_text_38: `'自社の商品を貸与することができるインフルエンサー'項目で'アンバサダーインフルエンサーのみ'または'一般インフルエンサーおよびアンバサダーインフルエンサー全て'を選択されると、選定したインフルエンサーに貸与が可能となります。`,
            ambassador_index_text_39: `自社商品の提供を${'\n'}受けたことのある${'\n'}インフルエンサー${'\n'}だけを見る`,
            ambassador_index_text_40: `お気に入りした${'\n'}インフルエンサー${'\n'}だけ見る`,
            ambassador_index_text_41: "最新順",
            ambassador_index_text_42: "評点順",
            ambassador_index_text_43: "フォロワー順",
            ambassador_index_text_44: "いいね順",
            ambassador_index_text_45: "お気に入り順",
            ambassador_index_text_47: "検索条件を変更してください。",
            ambassador_index_text_48: "アンバサダーインフルエンサーに選定する",
            ambassador_index_text_49: "選択したインフルエンサーをアンバサダーインフルエンサーに選定します。",
            ambassador_index_text_50: "選択したインフルエンサーをアンバサダーインフルエンサーから脱落させる。",
            ambassador_index_text_51: "一般インフルエンサー投稿ガイドラインにまず同意してください。",
            ambassador_index_text_52: "一般インフルエンサー投稿ガイドラインに同意していただくと利用が可能です。",
            ambassador_index_text_53: "同意しに行く",
            ambassador_index_text_54: "一般インフルエンサー投稿ガイドライン",
            ambassador_index_text_55: "ガイドラインを見る",
            ambassador_index_text_56: () => (
                <>
                    リール作成を望まれる場合、ガイドラインを設定後に商品別リールに
                    変更していただければ大丈夫です。
                </>
            ),
            ambassador_index_text_57: "投稿ガイドラインを設定する",
            ambassador_index_text_58: "リールガイドラインを設定する",
            ambassador_index_text_59: "一般インフルエンサーを通して投稿を作成した際の注意事項",
            ambassador_index_text_60: "1. 他のブランドと同時にタグ付けされる場合があります。",
            ambassador_index_text_61: "2. 他の協賛と一緒にタグ付けされることがあります。",
            ambassador_index_text_62: "タグガイドライン",
            ambassador_index_text_63: "写真ガイドライン",
            ambassador_index_text_64: "一般インフルエンサーガイドラインに同意する",
            ambassador_index_text_65: "一般インフルエンサーガイドラインに同意します。",
            ambassador_index_text_66: "同意すると一般インフルエンサーによる投稿作成が可能になります。",
            ambassador_index_text_67: "同意します",
            _ambassador_index_text_68: (count: number) => `応募したインフルエンサー数: ${count}`,
            ambassador_index_text_69: "問い合わせの受付が完了されました。",
            ambassador_index_text_70: "アンバサダーサービス利用問い合わせ",
            ambassador_index_text_71: "要請が進行中です。",
            ambassador_index_text_72: "選定が完了されました。",
            ambassador_index_text_73: `'私たちの商品を貸与することができるインフルエンサー'項目で'アンバサダーインフルエンサーだけ'もしくは'一般インフルエンサーおよびアンバサダーインフルエンサーどちらも'を選択されると選定したインフルエンサーに貸与が可能になります。`,
            ambassador_index_text_74: "脱落させるインフルエンサーを選択してください。",

            ambassador_index_text_75: "アンバサダーインフルエンサーを脱落させる",
            ambassador_index_text_76: "選択したインフルエンサーのアンバサダー応募を差し戻します。",
            ambassador_index_text_77: "アンバサダーインフルエンサーを中断させる",
            ambassador_index_text_78: "現在貸与中の服があるインフルエンサーがいる場合、該当貸与件まで投稿しｔら金額の請求が完了になり、その後該当インフルエンサーは利用が不可能となります。",
            ambassador_index_text_79: "アンバサダーインフルエンサーに選定する",
            ambassador_index_text_80: "選択したインフルエンサーをアンバサダーインフルエンサーに選定します。",
            ambassador_index_text_81: "選定するインフルエンサーを選択してください。",
            ambassador_index_text_82: "決済上限を上げることも考慮してみてください！",
            ambassador_index_text_83: "アンバサダー数を増やすことよりも決済上限を上げることがコンテンツ生産により役立つ状態です。",
            _ambassador_index_text_84: (
                currentAmbassadorCount,
                targetAmbassadorCount
            ) =>
                `アンバサダー募集を${targetAmbassadorCount}名以上選定してください！(現在${currentAmbassadorCount}/${targetAmbassadorCount}名)`,
            ambassador_index_text_85: "アンバサダーインフルエンサーが毎日商品を貸与してくれるとは限らないので、必ず必要人数よりも多くのアンバサダーインフルエンサーを選定しておかなければなりません。",
            ambassador_index_text_86: "決済上限を変更しに行く",
            ambassador_index_text_87: `감도 높은 ${getServiceName()}の${'\n'}おすすめインフル${'\n'}エンサーだけ見る`,
            ambassador_index_text_88: "アンバサダー選定順",
            ambassador_index_text_89: "ブランド再選択順",
            _ambassador_index_text_90: () => (
                <>
                    アンバサダーインフルエンサーとして活動中のブランド数です。<br />
                    アンバサダーインフルエンサーとしての活動を積極的にすればするほど良いインフルエンサーです。
                </>
            ),
            _ambassador_index_text_91: () => (
                <>
                    商品提供を2回以上進行したブランド数です。<br/>
                    再選択の回数が多いほど満足度が高いインフルエンサーです。
                </>
            ),
            ambassador_index_text_92: `未選定`,
            ambassador_index_text_93: `カテゴリー フィルター`,
            ambassador_index_text_94: `アクティブ度順`,
            _ambassador_index_text_95: () => (
              <>
                最近の{getServiceName}アプリ活動履歴があるモデルを優先的に表示します。
              </>
            ),
            _ambassador_index_text_96: (count: number) => `アンバサダーインフルエンサー数 : ${count}`,
            _ambassador_index_text_97: (count: number) => `未選定インフルエンサー数 : ${count}`,
            ambassador_index_text_98: `강력 추천!`,
            ambassador_index_text_99: `엠베서더를 계속 선정하면 AI가 학습을 통해 브랜드와 더 잘 맞는 인플루언서를 추천해 드립니다.`,
            ambassador_index_text_100: `일일이 선정하기 힘들다면, ${getServiceName()} 담당자에게 부탁해 보세요!`,
            ambassador_index_text_101: `(무로) 엠베서더 선정 대신 부탁하기`,
            ambassador_index_text_102: `의 감도 높은 인플루언서 목록을 이미 가지고 있습니다.`,
    
            ambassador_requirements_text_1: "該当イメージを削除されますか？",
            ambassador_requirements_text_2: "該当イメージの削除に成功しました。",
            ambassador_requirements_text_3: "アンバサダーインフルエンサー投稿ガイドライン",
            ambassador_requirements_text_4: "イメージガイドライン",
            ambassador_requirements_text_5: "1. 必須で投稿しなければならない写真を教えてください",
            ambassador_requirements_text_6: "入力されたメッセージはインフルエンサーに表示されます。",
            ambassador_requirements_text_7: "より具体的で直接的に表現してください。",
            ambassador_requirements_text_8: `MUSINSA snapで 使用 予定で, ${"\n\r"} 頭から 足先まで 切れないよう 強調　ない単語33`,
            ambassador_requirements_text_9: "禁止事項",
            ambassador_requirements_text_10: "2. 禁止事項が必要な場合はチェックしてください。",
            ambassador_requirements_text_11: "3. ブランドで追加するイメージ ガイドがあれば入れてください。(選択)",
            ambassador_requirements_text_12: "入力されたイメージはインフルエンサーに表示され、同意を受けます",
            ambassador_requirements_text_13: "文句ガイドライン",
            ambassador_requirements_text_14: "4. 投稿に必ず入れなければならない必須文句があれば教えてください",
            ambassador_requirements_text_15: "入力されたメッセージはインフルエンサーに表示されます",
            ambassador_requirements_text_16: "(例) 自社サイトで新商品10%割引中",
            ambassador_requirements_text_17: "タグガイドライン",
            ambassador_requirements_text_18: "5. ブランドのInstagram @公式アカウントを教えてください。",
            ambassador_requirements_text_19: "他ブランドのタグ",
            ambassador_requirements_text_20: "6. 投稿写真に他ブランドのタグが入ってもいいですか？",
            ambassador_requirements_text_21: (category_id) => {
                switch(category_id){
                case CATEGORY_ID.BEAUTY:
                return "7. SNSにリールをアップロードする際、一緒に挿入する#ハッシュタグを教えてください。";
                default:
                return "7. SNS投稿時に挿入する#ハッシュタグを教えてください。";
                }  
            },
            ambassador_requirements_text_22: "'#' を除外して文字だけ入力してください。",
            ambassador_requirements_text_23: "追加#タグ 設定",
            ambassador_requirements_text_24: `# を除外して文字だけ入力`,
            ambassador_requirements_text_25: "ハッシュタグ位置",
            ambassador_requirements_text_26: "8. ブランドハッシュタグが入る位置を選択してください。",
            ambassador_requirements_text_27: "PR および 提供",
            ambassador_requirements_text_28: "9. #提供 #PR タグ",
            ambassador_requirements_text_29: "入力内容を確認してください。",
            ambassador_requirements_text_30: "リールガイドラインを入力してください。",
            ambassador_requirements_text_31: "写真ガイドラインを除くか、1つ以上設定してください。",
            ambassador_requirements_text_32: "ブランドタグ入力エラーが発生しました。再接続してください。",
            ambassador_requirements_text_33: "ブランドタグを入力してください。",
            ambassador_requirements_text_34: "ハッシュタグ入力エラーが発生しました。再接続してください。",
            ambassador_requirements_text_35: "ハッシュタグを入力してください。",
            ambassador_requirements_text_36: "禁止事項を選択してください。",
            ambassador_requirements_text_37: "他ブランドのタグを許可するかどうかを選択してください。",
            ambassador_requirements_text_38: "ハッシュタグの位置を選択してください。",
            ambassador_requirements_text_39:
                "#PR #提供 タグの表記をするかどうかを選択してください。",
            ambassador_requirements_text_40: "すべて入力れました。",
            ambassador_requirements_text_41: "修正されました。",
            ambassador_requirements_text_42: "修正中にエラーが発生しました。再読み込み後、もう一度やり直してください。",
            ambassador_requirements_text_43: "該当イメージを削除されますか？",
            ambassador_requirements_text_44: "イメージを削除しました。",
            ambassador_requirements_text_45: "該当イメージの削除に成功しました。",
            ambassador_requirements_text_46: "必ず一つのオプションを選択しなければいけません。",
            ambassador_requirements_text_47: "アンバサダーインフルエンサー 投稿ガイドライン",
            ambassador_requirements_text_48: "イメージガイドライン",
            ambassador_requirements_text_49: "1. 必須で投稿しなければいけない写真を教えてください",
            ambassador_requirements_text_50: "コンテンツ作成難易度が高くなるほど、応募者数が減少",
            ambassador_requirements_text_56: "2. 禁止事項が必要な場合はチェックしてください。",
            ambassador_requirements_text_57: "3. ブランドで追加するイメージガイドがあれば入れてください。(選択)",
            ambassador_requirements_text_58: "入力されたイメージはインフルエンサーに表示され、同意を受けます。",
            ambassador_requirements_text_59: "文言ガイドライン",
            ambassador_requirements_text_60: "4. 投稿に必ず入れなければいけない必須文言があれば教えてください。",
            ambassador_requirements_text_61: "入力されたメッセージはインフルエンサーに表示されます。",
            ambassador_requirements_text_62: "(例)自社サイトで新商品10%割引中",
            ambassador_requirements_text_63: "タグガイドライン",
            ambassador_requirements_text_64: "5. ブランドのInstagram @公式アカウントを教えたください。",
            ambassador_requirements_text_65: "6. 投稿写真に他ブランドのタグが入っても良いですか？",
            ambassador_requirements_text_66: `*投稿時 @${getServiceNameEn()}、#${getServiceName()}タグは基本的に除かれます。`,
            ambassador_requirements_text_67: (category_id) => {
                switch(category_id){
                case CATEGORY_ID.BEAUTY:
                return "7. SNSにリールをアップロードする際、一緒に挿入する#ハッシュタグを教えてください。";
                default:
                return "7. SNS投稿時に挿入する#ハッシュタグを教えてください。";
                }  
            },                
            ambassador_requirements_text_68: "'#'は除いて文字のみ入力してください。",
            ambassador_requirements_text_69: "追加#タグ設定",
            ambassador_requirements_text_70: "#は除いて文字のみ入力",
            ambassador_requirements_text_71: "8. ブランドハッシュタグが入る位置を選択してください。",
            ambassador_requirements_text_72: "9. #PR #提供タグ",
            ambassador_requirements_text_73: "提出せずにParamsログだけ撮る",
            ambassador_requirements_text_74: "アンバサダーインフルエンサー リールガイドライン",
            ambassador_requirements_text_75: "リールガイドライン",
            ambassador_requirements_text_76: "1. 動画ガイドラインを教えてください。",
            ambassador_requirements_text_77: "より具体的で直接的に表現してください。",
            ambassador_requirements_text_78: "リールスの他に追加写真を受け取る",
            ambassador_requirements_text_79: "10. リールの他に写真も必要ですか？",
            ambassador_requirements_text_80: "必要ないです。",
            ambassador_requirements_text_81: "追加写真が必要です。\n(追加写真を要請するほど難易度が高くなり、応募率に影響を与えます。最大3枚の写真を要請することができます。)",
            ambassador_requirements_text_82: "ガイドライン修正時必須同意項目",
            ambassador_requirements_text_83: "以前ガイドラインに同意して服を貸与したインフルエンサーがいる場合、変更されたガイドラインに同意していなかったので変更されたガイドラインと関係なく投稿できることに同意しなければいけません。",
            ambassador_requirements_text_84: "同意します",
            ambassador_requirements_text_85: "修正されました",
            ambassador_requirements_text_86: "修正中にエラーが発生しました。再読み込み後もう一度実行してください。",
            ambassador_requirements_text_87: "写真ガイドラインを1つ以上設定してください",
            ambassador_requirements_text_88: "おすすめ",
            ambassador_requirements_text_89: [
                `他ブランドの商品と一緒に着用すると`,
                `よりクオリティーの高いインフルエンサーが着用する確率が高くなります。`,
                `ブランドは他ブランドと一緒に自然に露出する頻度が高くなります。`,
            ].join('\n'),
            ambassador_requirements_text_90: `*カフェでの室内撮影も禁止されます`,
            _ambassador_requirements_text_91: (current:number, maximum:number)=>(
                `(${current}/${maximum} ${maximum}文字以内)`
            ),
            ambassador_requirements_text_92: `参考にするリール動画例URL`,
            ambassador_requirements_text_93: "*リール作成の為、参考いただく為の動画です。",
            ambassador_preview_text_1: "アンバサダーサービスが利用できない状態です。",
            ambassador_preview_text_2: "アンバサダー貸与の対象ではありません。",
            ambassador_preview_text_3: "アンバサダーインフルエンサー応募者",
            _ambassador_preview_text_4: ()=>(
                <>PCでブランド管理者ページに接続して
                    <br />
                    アンバサダーインフルエンサーを選定してください！</>
            ),
            ambassador_preview_text_5: "アンバサダーインフルエンサーとは何ですか？",
            _ambassador_preview_text_6: ()=>(
                <>
                    {`お望みのインフルエンサーを直接`}
                    <br />
                    {`選択して商品を貸与してください`}
                </>
            ),
            ambassador_preview_text_7: `特定のインフルエンサーをアンバサダーインフルエンサーに選定すると、そのインフルエンサーだけに自社の商品を借りられるようにすることができます。簡単に言うと、お望みのインフルエンサーだけが直接選択して商品を借りられるようにすることができるという意味です。`,
            ambassador_preview_text_8: "詳細なガイドラインの設定が可能です",
            ambassador_preview_text_9: "アンバサダーインフルエンサーに商品を貸与する際にポーズ、#タグなどについて詳細にガイドラインを設定することができ、クオリティーが高い投稿を作成することができます。",
            _ambassador_preview_text_10: (unit: string) => `月1万${unit}から利用してみてください`,
            _ambassador_preview_text_11: (unit: string) => `アンバサダーインフルエンサーが投稿を作るごとに3,500${unit}が賦課され、このうち2,000${unit}がインフルエンサーに支給されます。したがって投稿のクオリティが一般インフルエンサーよりも高いことが期待できます。月の上限は1万${unit}から設定可能です。`,
            _ambassador_preview_text_12: (count: number) => `応募したインフルエンサー数 : ${count}`,
            ambassador_preview_text_13: "応募者がいません。",
            ambassador_preview_text_14: "背景写真を登録していない使用者です。",
            ambassador_preview_text_15: "お気に入り済",
            ambassador_preview_text_16: "インフルエンサーをお気に入りに追加",
            index_text_1: "신세계인터내셔날　ない単語34",
            index_text_2: "ブランド情報を呼び出せません。",
            index_text_3: "1. 商品を登録されましたか？",
            index_text_4: "商品登録しに行く",
            index_text_5: "2. 商品を送りましたか？",
            index_text_6: "はい、発送を完了しました。",
            index_text_7: `(04406) 서울시 용산구 보광로60길 3, 이화빌딩 3층${"\n"}(010-9635-9152)　ない単語35`,
            index_text_8: "3. カード登録を完了されましたか？",
            index_text_9: "カード登録をしに行く",
            index_text_10: "一般インフルエンサー",
            index_text_11: "アンバサダーインフルエンサー",
            index_text_12: "選択前",
            index_text_13: "一般インフルエンサーのみ",
            index_text_14: "アンバサダーインフルエンサーのみ",
            index_text_15: "一般インフルエンサーおよびアンバサダーインフルエンサー両方",
            index_text_16: "商品貸与",
            index_text_17: "1. 商品",
            index_text_18: "入庫された数",
            index_text_19: "登録は完了したが検収ができていない商品数",
            index_text_20: "回収を要請した商品数",
            index_text_21: "2. 決済",
            index_text_22: "月 決済上限ライン",
            index_text_23: "月 決済上限ライン以上は決済ができません。",
            index_text_24: "VAT 別途",
            _index_text_25: (month: any) => `${month}月 請求予定金額`,
            _index_text_26: (currentMonth: any, nextMonth: any) => `${currentMonth}月に利用した金額は${nextMonth}月15日に決済される予定です。`,
            index_text_27: "VAT 別途",
            index_text_28: "3. インフルエンサー選定",
            index_text_29: "自社の服を貸与できるインフルエンサー",
            index_text_30: "選定待機中のアンバサダーインフルエンサー応募者数",
            index_text_31: "インフルエンサー1名が1ヶ月間に最大着用可能な商品数",
            index_text_32: "4. 投稿",
            _index_text_33: (month: any) => `${month}月 完了した投稿数`,
            _index_text_34: (amount: any) => `アンバサダー投稿${amount}個`,
            _index_text_35: (amount: any) => `一般投稿${amount}個`,
            _index_text_36: (month: any) => `${month}月 作成中の投稿数`,
            index_text_37: "コピー完了",
            index_text_38: "コピーが完了されました。",
            index_text_39: "コピー失敗",
            index_text_40: "コピーが制限されました。",
            index_text_41: "コピー",
            _index_text_42: () => (
                <>
                    下記全ての段階を完了したとき
                    <br />
                    投稿作成が始まります。
                </>
            ),
            intro_text_1: "インフルエンサーに商品を貸与をして、",
            intro_text_2: "コンテンツを作ってください",
            intro_text_3: "クオリティーの高いコンテンツをお作りします",
            intro_text_4: "紹介書ダウンロード",
            intro_text_5: `商品提供(ギフティング)をするには `,
            intro_text_6: `単価がとても高いですか？`,
            intro_text_7: `商品ひとつで複数人のインフルエンサーに貸与し`,
            intro_text_8: `コンテンツを得ることができます。`,
            intro_text_9: "Check Point 1",
            intro_text_10: "Check Point 2",
            intro_text_11: `衣装だけ預ければ${getServiceName()}が`,
            intro_text_12: `衣装だけ提供していただければ洗濯/運営/コンテンツ制作`,
            intro_text_13: `全て${getServiceName()}が行います。`,
            intro_text_14: "Check Point 3",
            intro_text_15: "自社の洗濯施設で綺麗に衣装管理",
            intro_text_16: "毎貸与ごとに洗濯を実行します。",
            intro_text_17: "作成されたコンテンツ 無制限2次利用",
            intro_text_18: `MUSINSA snap, 広告, 自社モール, Instagram など　ない単語36 `,
            intro_text_19: `お好きなところに自由に使用`,
            intro_text_20: "Check Point 5",
            intro_text_21: "2,000名のインフルエンサーとともにします　ない単語37",
            intro_text_22: "フェミニン/カジュアル/セクシー/ゴルフなど多様なスタイルのインフルエンサー",
            intro_text_23: "Check Point 6",
            intro_text_24: `アンバサダーインフルエンサーを選定して`,
            intro_text_25: `お望みのインフルエンサーにだけ`,
            intro_text_26: `服を貸してください`,
            intro_text_27: `4,000名のインフルエンサーのうち ない単語38`,
            intro_text_28: `ブランドのイメージに合うインフルエンサーの選択が可能`,
            intro_text_29: "Check Point 4",
            intro_text_30: "Check Point 7",
            intro_text_31: "精巧なガイドラインを選定可能",
            intro_text_32: "投稿の満足度上昇",
            intro_text_33: "Check Point 8",
            _intro_text_34: (unit: string) => `月1万${unit}から利用可能な料金制`,
            intro_text_35: "負担なしで合理的に利用可能な価格",
            intro_text_36: "400+個ブランドが利用中 ない単語39",
            intro_text_37: `高い満足度で`,
            intro_text_38: `とても低い離脱率になっています。`,
            intro_text_39: "紹介書ダウンロード",
            intro_text_41: () => (
                <>
                    {`1つの商品で`}
                    <br />
                    {`多くのコンテンツを作成してみてください`}
                </>
            ),
            intro_text_42: () => (
                <>
                    {`下記と同様の場合、`}
                    <br className="flex md:hidden" />
                    {`商品貸与によるコンテンツの作成が正解です..`}
                </>
            ),
            intro_text_43: () => (
                <>
                    {`商品だけ預ければ`}
                    <br />
                    {`${getServiceName()}がすべて行います`}
                </>
            ),
            intro_text_44: () => (
                <>
                    {`${getServiceName()}は芸能人広告代理店の`}
                    <br className="flex md:hidden" />
                    {`オンラインインフルエンサーバージョンです。`}
                </>
            ),
            intro_text_45: () => (
                <>
                    {`4,000名のインフルエンサーと　ない単語40`}
                    <br />
                    {`共にしています`}
                </>
            ),
            intro_text_46: () => (
                <>
                    {`フェミニン/カジュアル/セクシー/ゴルフなど`}
                    <br className="flex md:hidden" />
                    {`スタイルが多様です。`}
                </>
            ),
            intro_text_47: () => (
                <>
                    {`アンバサダーインフルエンサーを選定して、`}
                    <br />
                    {`お望みのインフルエンサーにだけ`}
                    <br className="flex md:hidden" />
                    {`商品を貸与してください`}
                </>
            ),
            intro_text_48: () => (
                <>
                    {`4,000名のインフルエンサーと　ない単語41 `}
                    <br className="flex md:hidden" />
                    {`自社ブランドのイメージと合うインフルエンサーの選択が可能です。`}
                </>
            ),
            intro_text_49: () => (
                <>
                    {`一般インフルエンサーと`}
                    <br />
                    {`アンバサダーインフルエンサーを比較`}
                </>
            ),
            intro_text_50: `どんな違いがあるか一目で確認してみてください。`,
            intro_text_51: () => (
                <>
                    {`アンバサダー投稿は`}
                    <br />
                    {`精巧なガイドライン設定が可能`}
                </>
            ),
            intro_text_52: `ブランドが直接ガイドラインを設定することができます。`,
            intro_text_53: () => (
                <>
                    {`コンテンツの2次利用は`}
                    <br />
                    {`無制限無料`}
                </>
            ),
            intro_text_54: () => (
                <>
                    {`お望みの用途、期間の制限なしで`}
                    <br className="flex md:hidden" />
                    {`無料で利用することができます`}
                </>
            ),
            intro_text_55: () => (
                <>
                    {`400+個の　ない単語42`}
                    <br />
                    {`ブランドが利用中`}
                </>
            ),
            intro_text_56: () => `高い満足度でとても低い離脱率を見せています。`,

            _payments_budget_option: (unit: string) => [
                { name: `1万${unit}`, value: 100000 },
                { name: `2万${unit}`, value: 200000 },
                { name: `3万${unit}`, value: 300000 },
                { name: `5万${unit}`, value: 500000 },
                { name: `10万${unit}`, value: 1000000 },
                { name: `20万${unit}`, value: 2000000 },
                { name: `50万${unit}`, value: 5000000 },
                { name: `100万${unit}`, value: 10000000 },
            ],

            payments_text_1: "決済予定金額より低い上限ラインを設定しました。",
            _payments_text_2: (money: any, amount: any, unit: string) => `今月の貸与は ${money}${unit}か中断します。\n来月からは ${amount}${unit}までのみ決済される予定です。`,
            payments_text_3: "カード登録する",
            payments_text_4: "月決済上限ライン(VAT 別途)",
            _payments_text_5: (unit: string) => `月決済上限ラインで決まった金額はVATを後に返してもらえるのでVAT別途金額で決済されます。月決済の上限で決まった金額のVATは後に戻ってくるのでVAT別の金額で決済されます。${"\n"}(例:月決済上限ラインを10万${unit}に設定時、実際の決済金額はVAT10%が追加された11万${unit}　ない単語)`,
            payments_text_6: "月決済上限ライン設定完了",
            payments_text_7: `月決済上限ラインを無制限で設定します。${"\n"}(VAT 別途)`,
            payments_text_8: "金額 直接入力",
            _payments_text_9: (unit: string) => `万${unit}`,
            _payments_text_10: (unit: string) => `${unit}`,
            _payments_text_11: (budget: any, suffix: any) => `月決済上限ラインを${budget || 0}${suffix}に設定します。${"\n"}(VAT 別途)`,
            payments_text_12: "決済予定金額",
            payments_text_13: `1. 投稿検収まで完了したら請求します。\n2.現在貸与中の商品が投稿されない場合は請求しません。`,
            payments_text_14: "登録されたカードがありません。",
            payments_text_15: "カード管理メニューに移動する",
            payments_text_16: "サービス利用を中断する",
            _payments_text_17: (month: any, money: any, unit: string) => `${month}月決済予定金額 ${money}${unit}をすぐに決済します。(VAT 別途)\n進行中のサービスが中断され商品はすぐに返却されます。`,
            _payments_text_18: (month: any) => `${month}月決済予定金額がありません。\n進行中のサービスが中断され、商品はすぐに返却されます。`,
            payments_text_19: `サービス利用を中断します`,
            payments_text_20: "引き続き利用します",
            payments_text_21: "決済されます",
            payments_text_22: "決済されました。",
            payments_text_23: "決済予定です。",
            _payments_text_24: (month: any) => `${month}月に利用した金額は`,
            _payments_text_25: (month: any, paidStatusText: any) => `${month}月15日に${paidStatusText}`,
            payments_text_26: "最終決済予定金額",
            payments_text_27: `商品は貸与中だが投稿が未完了であれば${"\n"}最終決済予定金額より少なく決済されます。`,
            payments_text_28: "VAT 別途",
            payments_text_29: "一般インフルエンサー",
            payments_text_30: "完了された投稿",
            _payments_text_31: (count: any) => `投稿${count}個`,
            payments_text_32: "作成中の投稿",
            payments_text_33: "アンバサダーインフルエンサー",
            _payments_text_34: (unit: string) => `1ヶ月に30個の投稿を嫌いすることができます。${"\n"}(3,500${unit}*30個=105,000${unit})`,
            payments_text_35: "ブランドの80%が利用中。",
        },
        reports: {
            index_text_1: "人気が高い順",
            index_text_2: "人気が低い順",
            index_text_3: "最近2週",
            index_text_4: "月別",
            index_text_5: "商品目録を呼び出しましたが失敗しました。",
            index_text_6: "2週レポート",
            index_text_7: "商品貸与",
            _index_text_8: (totalClothes: any, diffFromLastApprovedDate: any) => (
                <>
                    <div className="flex flex-row">
                        <span className="text-[20px] heading-snug tracking-tighter text-white">{`現在全`}</span>
                        <span className="text-[20px] heading-snug tracking-tighter text-[#000000]">{`${totalClothes ?? "0"}着が`}</span>
                        <span className="text-[20px] heading-snug tracking-tighter text-white">{`入庫されていて、`}</span>
                    </div>
                    <div className="flex flex-row">
                        <span className="text-[20px] heading-snug tracking-tighter text-white">{`最終入庫日から`}</span>
                        <span className="text-[20px] heading-snug tracking-tighter text-[#EF5DA8]">{`${diffFromLastApprovedDate ? diffFromLastApprovedDate : "0"}日`}</span>
                        <span className="text-[20px] heading-snug tracking-tighter text-white">{`過ぎました`}</span>
                    </div>
                </>
            ),
            _index_text_9: (brandName: any) => `${brandName}の最終入庫日: `,
            index_text_10: "商品提供",
            index_text_11: "すぐ行く",
            _index_text_12: (totalCampaigns: any) => (
                <>
                    現在<b className="text-[#5D5FE7]">210個のブランド</b>が商品提供中で、
                    <br />
                    これまで<b className="text-[#DD66A6]">{`${totalCampaigns}回`}</b>回行いました。
                </>
            ),
            index_text_13: "最近2週 人気順位",
            index_text_14: "人気衣装はあらかじめ追加入庫を考えてください！😊",
            index_text_15: "全体を見る",
            index_text_16: "衣装サムネイル",
            index_text_17: "クリック数",
            index_text_18: "入庫されている",
            index_text_19: "チャート情報を呼び出しましたが失敗しました。",
            _index_text_20: (count: any) => `投稿 : ${count}件`,

            index_text_21: "投稿現況グラフ",
            _index_text_22: (count: any) => `累積個数 : ${count}個`,
            _index_text_23: (month: any, day: any) => `${month}月${day}日`,
            index_text_24: "最近2週 投稿",
            index_text_25: "全体の投稿を見る",
            index_text_26: "ホワイトラベル 機能 アップデート！　ない単語43",
        },
        settings: {
            alarm_text_1: "ブランド情報を呼び出せません。",
            alarm_text_2: "通知設定",
            alarm_text_3: "ニュースレター購読 : 2週に1回ずつニュースレターをお送りします。",
            alarm_text_4: "インスタリンク : 投稿リンクをリアルタイムでお送りします。",
            alarm_text_5: "アンバサダー応募 : アンバサダー応募時、通知をお送りします。",
            alarm_text_6: "貸与予算警告 : 貸与予算が不足した場合、通知をお送りします。",
            alarm_text_7: "担当者Eメール",
            alarm_text_8: "DEPRECATED_リールファイルを受け取るメールアドレス",
            alarm_text_9: "担当者情報",
            alarm_text_10: "作成された投稿と投稿結果を定期的にお送りします。",
            alarm_text_11: "ブランド情報の修正に失敗しました。",
            alarm_text_12: "社長情報",
            alarm_text_13: "社長",
            alarm_text_14: "役職を入力してください。",
            alarm_text_15: "連絡先をご確認ください。",
            brand_text_1: "@タグの設定を進行してください。",
            brand_text_2: "ブランド情報設定",
            brand_text_3: "アプリに表示されるロゴイメージ (必須)",
            brand_text_4: "@タグ設定",
            brand_text_5: (category_id) => {
                switch(category_id){
                case CATEGORY_ID.BEAUTY:
                return "Instagramにリールをアップロードする際、挿入する公式アカウントを記載してください。";
                default:
                return "インスタリンク投稿時に入力される@タグを2個記入してください。";
                }  
            },
            brand_text_6: "@を除外して文字のみ入力",
            brand_text_7: "#タグ設定",
            _brand_text_8: () => (
                <>
                    Instagram投稿時に入力される#タグを2個記入してください。
                    <br />
                    商品提供キャンペーン作成時に追加することができます。
                </>
            ),
            brand_text_9: "#を除外して文字のみ入力",
            brand_text_10: "保存する",
            brand_text_11: "ブランド情報の修正に失敗しました。",
            brand_text_12: "ロゴイメージを登録してください。",
            guide_menu_1: "基本ガイドライン",
            guide_menu_2: "ブランドで作ったガイドライン",
            guide_text_1: "インフルエンサーに表示する投稿ガイドラインです。",
            guide_text_2: "該当ガイドを削除されますか？",
            guide_text_3: "該当イメージの削除に成功しました。",
            password_text_1: "ブランド情報を呼び出せません。",
            password_text_2: "パスワード変更",
            password_text_3: "既存のパスワードを入力してください。",
            password_text_4: "変更するパスワードを入力してください。",
            password_text_5: "変更するパスワードをもう一度入力してください。",
            password_text_6: "変更するパスワードの再確認欄を入力してください。",
        },
        sns: {
            uploader_text_1: "代表イメージ",
            uploader_text_3: "詳細ページURL",
            uploader_text_4: "着用色",
            uploader_text_5: "着用サイズ",
            uploader_text_6: "商品追加する +",
            uploader_text_7: "代表イメージを設定してください",
            uploader_text_8: "商品名を入力してください",
            uploader_text_9: "詳細ページURLを入力してください",
            uploader_text_10: "着用色を入力してください",
            uploader_text_11: "着用サイズを入力してください",
            uploader_text_12: "商品追加中です。",
            uploader_text_13: "商品を追加できません。",
            celeb_detail_text_1: "ブランド情報を呼び出せません。",
            celeb_detail_text_2: "芸能人レビュー情報を呼び出せません。",
            celeb_detail_text_3: "修正中です。",
            celeb_detail_text_4: "芸能人レビュー情報を修正できません。",
            celeb_detail_text_7: "コンテンツを修正する",
            celeb_detail_text_8: "商品情報",
            celeb_order_text_1: "芸能人レビュー",
            celeb_upload_text_1: "直接上げる",
            celeb_upload_text_2: "サムネイル代表イメージ",
            celeb_upload_text_3: "詳細イメージ",
            celeb_upload_text_4: "商品情報",
            celeb_upload_text_5: "過去の商品情報呼び出し",
            celeb_upload_text_6: "投稿を登録する",
            celeb_upload_text_7: "題名を入力してください",
            celeb_upload_text_8: "商品を１つ以上選択してください",
            celeb_upload_text_9: "サムネイル代表イメージを設定してください",
            celeb_upload_text_10: "詳細イメージを１つ以上設定してください",
            celeb_upload_text_11: "アップロード中です。",
            celeb_upload_text_12: "芸能人レビュー情報を作成/修正できません。",
            celeb_upload_text_13: "登録が完了しました。",
            celeb_upload_text_14: "投稿登録に失敗しました。",
            index_text_1: "ブランド情報を呼び出せません。",
            index_text_2: "呼び出し中です",
            _index_text_3: (name: string) => `${name} がないです`,
            _index_text_4: (name: string) => `${name} 情報を呼び出せません。`,
            index_text_5: "修正中です",
            _index_text_6: (name: string) => `${name} 情報を修正できません。`,
            index_text_7: "YouTubeレビュー",
            index_text_8: "自社サイト連動および管理",
            index_text_9: "コンテンツ順序を変更する",
            index_text_10: "コンテンツを直接上げる",
            _index_text_11: (name: string) => `${name} もっと見る`,
            product_text_1: "商品名検索",
            _resource_text_1: (name: string) => `${name} 順序を変更する`,
            _resource_text_2: (name: string) => (
                <>
                    クリックして引っ張ってくると順序を変更することができます。
                    <br />
                    公開された{name}だけ表示します。
                </>
            ),
            _resource_text_3: (name: string) => `公開された${name}情報がありません。`,
            resource_text_4: "変更中です。",
            _resource_text_5: (name: string) => `${name}情報を修正できません。`,
            resource_text_6: "順序変更完了",
            right_side_text_1: "URLを変更する",
            right_side_text_2: "商品の詳細ページURLを入力してください。",
            video_detail_text_1: "ビデオレビュー情報を呼び出せません。",
            video_detail_text_2: "ビデオレビュー情報を修正できません。",
            video_upload_text_1: "ビデオ情報を呼び出せません。",
            video_upload_text_2: "ビデオレビュー",
            video_upload_text_3: "URLを入力してください",
            video_upload_text_4: "ビデオレビュー情報を作成/修正できません。",
            youtube_detail_text_1: "YouTubeレビュー情報を呼び出せません。",
            youtube_detail_text_2: "YouTubeレビュー情報を修正できません。",
            youtube_upload_text_1: "YouTube情報を呼び出せません。",
            youtube_upload_text_2: "YouTubeレビュー情報を作成/修正できません。",
            create_text_1: "投稿写真を削除する",
            create_text_2: "削除されたイメージは復旧できません。該当イメージを削除されますか？",
            create_text_3: "プロフィール写真を削除する",
            create_text_4: "プロフィール写真(選択)",
            create_text_5: "商品代表イメージを削除する",
            create_text_6: "代表イメージ",
            create_text_7: "商品を削除する",
            create_text_8: "投稿を修正する",
            create_text_9: "投稿を登録する",
            create_text_10: "投稿写真",
            create_text_11: "順序変更",
            create_text_12: "インフルエンサー情報",
            create_text_13: "トップスサイズ",
            create_text_14: "ボトムスサイズ",
            create_text_15: "靴サイズ(選択)",
            create_text_16: "ブラサイズ(選択)",
            create_text_17: "パンティーサイズ(選択)",
            create_text_18: "投稿写真を登録してください。",
            create_text_19: "インフルエンサーの名前を入力してください。",
            create_text_20: "インフルエンサーの年齢を入力してください。",
            create_text_21: "インフルエンサーの身長を入力してください。",
            create_text_22: "インフルエンサーのトップスサイズを入力してください。",
            create_text_23: "インフルエンサーのボトムスサイズを入力してください。",
            create_text_24: "1個以上の商品を追加してください",
            create_text_25: "一部商品のイメージが抜けています。",
            create_text_26: "一部商品の品名が抜けています。",
            create_text_27: "一部商品のURLが抜けています。",
            create_text_28: "一部商品の色が抜けています。",
            create_text_29: "一部商品のサイズが抜けています。",
            create_text_30: "自社サイトに露出される情報です。以降修正は可能ですが、反映に時間がかかるのでそれぞれの情報を正確に入力してください。(特にURLは自社サイトで該当商品を押したときに移動するリンクなので、動作を確認してください。)",
            index_text_21: "自社サイト連動する",
            _index_text_22: () => (
                <>
                    まず決済を進行されるなら
                    <br />
                    {getServiceName()}開発チームが24時間以内に
                    <br />
                    自社サイトに設置を始めます。
                </>
            ),
            index_text_22: "",
            index_text_23: "* 設置完了時点から利用期間のカウントが始まります。",
            index_text_24: "決済を進行する",
            index_text_25: "自社サイト連動紹介を見る",
            _index_text_26: () => (
                <>
                    自社サイト連動手続きが <br />
                    気になりますか？
                </>
            ),
            index_text_26: `${getServiceName()}開発チームが自社サイトに設置`,
            index_text_27: "利用開始",
            index_text_28: "ブランドが自社サイトに表示する投稿管理",
            index_text_29: "公開投稿のみ見る",
            index_text_30: "非公開投稿のみ見る",
            index_text_31: "投稿がありません。",
            intro_text_1: "自社サイト連動問い合わせ",
            intro_text_2: "黒澤 杏香",
            intro_text_3: "MUSINSA snapと 同じ 機能　ない単語44",
            intro_text_4: "自社サイトに入れてください",
            intro_text_5: "自社サイトに投稿を連動いたします。",
            intro_text_6: "紹介書ダウンロード",
            intro_text_7: "提携問い合わせ",
            intro_text_8: "Check Point 1",
            intro_text_9: "なぜ自社サイトに集中しなければならないのか？",
            intro_text_10: `手数料のない自社サイトで売上を`,
            intro_text_11: `上げることが重要です。`,
            intro_text_12: "Check Point 2",
            intro_text_13: `顧客のコンテンツ消費量が伸びるほど`,
            intro_text_14: `購買転換率は上がります`,
            intro_text_15: `良質なコンテンツは顧客の再訪問頻度、および`,
            intro_text_16: `滞留時間を伸ばしてくれます。`,
            intro_text_17: "Check Point 3",
            _intro_text_18: () => (
                <>
                    大型プラットフォームは
                    <br className="flex md:hidden" />
                    既にコンテンツの重要性を強調中
                </>
            ),
            _intro_text_19: () => (
                <>
                    {`MUSINSAの "snap", 크림의 "스타일　ない単語45", `}
                    <br className="flex md:hidden" />
                    {`지그재그의 "데일리피드　ない単語46"`}
                </>
            ),
            intro_text_20: "とても簡単な使用方法",
            _intro_text_21: () => (
                <>
                    {`管理者ページにてクリック１回で`}
                    <br className="flex md:hidden" />
                    {`投稿を自社サイトに露出することができます。`}
                </>
            ),
            intro_text_22: "多様なコンテンツのアップロードが可能",
            _intro_text_23: () => (
                <>
                    {`持っている写真コンテンツを直接上げることも、`}
                    <br />
                    {`YouTube動画をアップロードすることも全て可能です。`}
                </>
            ),
            intro_text_24: "担当者を割り当て中です...",
            intro_text_25: "担当者の割り当てが完了しました。",
            intro_text_26: "黒澤 杏香",
            _intro_text_27: (name: any) => (
                <>
                    {name} 担当者様、はじめまして。
                    <br />
                    5分以内にお電話いたします。
                    <br />
                    後ほどよろしくお願いいたします！
                </>
            ),
            order_postings_text_1: "投稿順序を変更する",
            _order_postings_text_2: () => (
                <>
                    投稿をクリックして引っ張ってくると順序を変更することができます。
                    <br />
                    公開投稿のみ表示します。
                </>
            ),
            order_postings_text_3: "投稿がありません。",
            order_postings_text_4: "変更中です",
            order_postings_text_5: "順序変更完了",
            payments_bills_text_1: "自社サイト連動設置費用",
            payments_bills_text_2: "自社サイト連動利用費用",
            payments_bills_text_3: "自動決済を中止する",
            _payments_cancel_complete_text_1: () => (
                <>
                    自社サイト連動利用権
                    <br />
                    自動決済が中止されました。
                </>
            ),
            _payments_cancel_complete_text_2: () => (
                <>
                    自社サイト連動利用権をもう一度購入したいのあれば、
                    <br />
                    <b>上段メニュー[自社サイト連動]</b>を押して利用してください。
                </>
            ),
            _payments_cancel_complete_text_3: (date: any) => (
                <>中止時には{date}日まで使用が可能です。</>
            ),
            payments_cancel_complete_text_4: "このまま維持する",
            payments_cancel_complete_text_5: "自動決済を中止する",

            payments_complete_text_1: "決済完了",
            _payments_complete_text_2: (days: number) => (
                <>
                    {getServiceName()}開発チームが設置する為
                    <br /> 24時間以内にLINEでご連絡を差し上げます。ない単語
                    <br /> (設置時間 約1日)
                    <br />
                    <br />
                    設置が完了した時点から
                    <br />
                    利用期間({days}日)のカウントが始まります。
                </>
            ),
            payments_index_text_1: "決済内訳がありません。",
            payments_index_text_2: "購買分類",
            show_index_text_1: "原本で復旧する",
            show_index_text_2: "クロップした写真を原本で復旧します。",
            show_index_text_3: "クロップする",
            show_index_text_4: "順序変更",
        },
        inspection_feedback: {
          inspection_overdue_time : `検収時間が終了しました。`,
          inspection_overdue_text : `ご入力いただいた内容はインフルエンサーに即時送信されます。`,
          inspection_save_button_text : `下書き保存して終了`,
          inspection_store_button_text : `検収完了`,
          inspection_save_modal_title: `下書き保存して終了しますか？`,
          inspection_save_modal_text: `再度アクセスして修正は可能ですが、\nその間に検収時間が終了した場合、ご入力いただいた内容が自動的にインフルエンサーへ送信されます。`,
          inspection_store_modal_decline_feedback_title: `検収を完了しますか？`,
          inspection_store_modal_decline_feedback_text: `検収を完了すると再度修正依頼はできず、${'\n'}ご入力いただいた内容はインフルエンサーに即時送信されます。`,
          inspection_store_modal_approve_feedback_title: `検収を完了しますか？`,
          inspection_store_modal_approve_feedback_text: `検収を完了すると再度修正依頼はできません。`,
          inspection_remain_time : (remainTimeStr) => `${remainTimeStr}以内に検収する`,
          inspection_remain_time_2 : (remainTimeStr) => `${remainTimeStr}残り`,
          inspection_title_completed: `검수 종료`,
          feedback_introduction: `검수는 1회만 가능하며, 인플루언서가 수정 후 글로브 검수팀의 검수를 받은 후 바로 인스타그램에 업로드를 진행합니다.\n재촬영을 제외한 자막, 폰트, 배경음악 등의 수정 요청이 가능합니다.`,
          show_guidelines: `このキャンペーンのガイドラインを見る`,
          inspection_capture_image_title: `特定シーンをキャプチャして修正依頼を残す`,
          inspection_capture_current_sequence : (timestamp)=> `${timestamp}のシーンをキャプチャする`,
          inspection_capture_no_image : `캡쳐한 장면이 없습니다`,
          inspection_feedback_guideline_title : `가이드라인 위반 내역`,
          inspection_feedback_guideline_placeholder : `(예) 비포&애프터 컷을 필수 장면으로 요청했는데, 영상에 들어가있지 않네요.`,
          inspection_feedback_subtitle_font_title : `字幕フォント変更（動画全体に適用）`,
          inspection_feedback_subtitle_font_placeholder : `(예) 영상 전반에 걸쳐 귀여운 폰트를 사용했는데, 가독성이 높은 고딕 계열 폰트로 전부 변경해 주세요.`,
          inspection_feedback_subtitle_size_title : `字幕サイズ変更（動画全体に適用）`,
          inspection_feedback_subtitle_size_placeholder : `(예) 영상 전반에 걸쳐 자막이 깨알 같은 크기로 들어가 있는데, 가독성이 높아지도록 크기를 전부 1.5배 키워주세요.`,
          inspection_feedback_background_music_title : `BGM差し替え`,
          inspection_feedback_background_music_desc_with_partnership : (
            <>
              パートナーシップ広告予定のキャンペーンのため、必ず著作権問題のない音源を使用する必要があります。<br />
              <br />
              もし現在ご覧の事前チェック用動画にBGMが入っていない場合、<br />
              インフルエンサーがInstagramにアップロードする際に音楽を挿入する可能性が高く、その場合必ず著作権問題が発生します。<br />
              <br />
              下記入力欄に「外部編集段階で音源を挿入して動画を完成させた後、Instagramにアップロードしてください。」と記載してください。
            </>
          ),
          inspection_feedback_background_music_desc_without_partnership : (
            <>
              Instagramにアップロードする際に音楽を挿入することがあるため、事前チェック用動画ファイルにはBGMが含まれていない場合があります。
            </>
          ),
          inspection_feedback_background_music_placeholder : `(예) 유행하는 K-POP 노래를 배경음악으로 사용했는데, 잔잔한 재즈 음악으로 변경해 주세요.`,
          inspection_feedback_guideline_violate : `ガイドラインに違反しています。`,
          inspection_feedback_narration_add_title : `ナレーション追加`,
          inspection_feedback_narration_add_desc : `ナレーション追加は再撮影に該当するため、ガイドライン違反でない限り依頼することはできません。.`,
          inspection_feedback_narration_add_placeholder : `나레이션 관련 가이드라인 위반 내용 및 요청사항 입력`,
          inspection_feedback_narration_edit_title : `ナレーション修正`,
          inspection_feedback_narration_edit_desc : `ナレーション修正は再撮影に該当するため、ガイドライン違反でない限り依頼することはできません。`,
          inspection_feedback_narration_edit_placeholder : `나레이션 관련 가이드라인 위반 내용 및 요청사항 입력`,
          inspection_feedback_narration_delete_title : `ナレーション削除`,
          inspection_feedback_narration_delete_desc : `삭제하고자 하는 나레이션이 포함된 장면을 캡쳐하여 해당 장면에 요청을 남겨주세요.`,
        }
    },
    guidelineTitles:{
        PHOTO_MODEL_FULL: '商品着用ショット-正面で立って(頭・つま先が切れないように)',
        PHOTO_MODEL_HALF: '商品着用ショット-半身ショット',
        PHOTO_MODEL_CLOSEUP: '商品着用ショット-商品ディテールクローズアップ',
        PHOTO_PRODUCT_FULL: '商品単独ショット-商品全体ショット',
        PHOTO_PRODUCT_CLOSEUP: '商品単独ショット-商品ディテールクローズアップ',
    },
};

export default ja;
